(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.HYBIRD = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    var TYPE;
    (function (TYPE) {
        TYPE["LOG"] = "log";
        TYPE["ERROR"] = "error";
        TYPE["WARN"] = "warn";
    })(TYPE || (TYPE = {}));
    var log = function (isDev) { return function (message, type) {
        if (type === void 0) { type = TYPE.LOG; }
        if (!isDev)
            return;
        console[type](message);
    }; };

    /** @format */
    // 始终打日志
    var logAllTime = log(true);
    var hasJS = function (url) {
        var scripts = Array.from(document.getElementsByTagName('script') || []);
        var srcs = [];
        scripts.forEach(function (item) {
            srcs.push(item.src);
        });
        return !!~srcs.indexOf(url);
    };
    var load = function (url) {
        if (typeof window !== 'object') {
            return Promise.reject({ message: 'in load function: window is not defined' });
        }
        if (hasJS(url)) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = 'async';
            script.crossorigin = 'anonymous';
            script.onload = script.onreadystatechange = function () {
                resolve();
            };
            script.onerror = function () {
                reject({ message: 'in load function: load js on error event' });
                head.removeChild(script);
            };
            script.src = url;
            head.appendChild(script);
        });
    };
    var loadByQueue = function (urls) {
        if (typeof urls === 'string') {
            return load(urls);
        }
        return (function () { return __awaiter(void 0, void 0, Promise, function () {
            var i, length, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        i = 0, length = urls.length;
                        _a.label = 1;
                    case 1:
                        if (!(i < length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, load(urls[i])];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i += 1;
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        logAllTime(e_1);
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 6: return [2 /*return*/, Promise.resolve()];
                }
            });
        }); })();
    };

    /** @format */
    var TYPE$1;
    (function (TYPE) {
        TYPE["ANJUKE"] = "anjuke";
        TYPE["WUBA"] = "wuba";
        TYPE["TONGZHEN"] = "tongzhen";
        TYPE["BROKER"] = "broker";
        TYPE["WEB"] = "web";
        TYPE["MINIPROGRAM"] = "miniprogram";
        TYPE["WEIXIN"] = "weixin";
        TYPE["VR"] = "vr";
        TYPE["WEAPP"] = "miniprogram";
        TYPE["BDAPP"] = "bdapp";
        TYPE["TTAPP"] = "ttapp";
        TYPE["ZFBAPP"] = "zfbapp";
        TYPE["KSAPP"] = "ksapp";
    })(TYPE$1 || (TYPE$1 = {}));
    function getAppByUA() {
        var userAgent = navigator.userAgent || '';
        var BrokerFlag = 'ajk-broker';
        var AnjukeFlag = 'AJK';
        var AnjukeReg = /AJK[a-zA-Z]*\/([\d.]*)/i;
        var WubaFlag = 'WUBA';
        var WubaReg = /WUBA\/(.*)/i;
        var TongzhenFlag = 'wbutown';
        var TongzhenReg = /wbutown\/(.*)/i;
        // const weappFlag = 'miniprogram'; // 微信小程序
        var weappReg = /MicroMessenger\/([\d.]*)/;
        // const bdappFlag = 'swan-baiduboxapp'; // 百度小程序
        var bdappReg = /swan-baiduboxapp\/([\d.]*)/;
        var ttappReg = /ToutiaoMicroApp\/([\d.]*)/; // 抖音小程序
        var zfbappReg = /AlipayClient\/([\d.]*)/; // 支付宝小程序
        var ksappReg = /kwapp\/([\d.]*)/; // 快手小程序
        // 分别为（微信、支付宝）、抖音、百度、快手小程序
        // const miniObj = {
        // 	miniprogram: 'WEAPP',
        // 	alipayclient: 'ZFBAPP',
        // 	toutiaomicroapp: 'BDAPP',
        // 	'swan-baiduboxapp': 'BDAPP'
        // };
        console.log('====userAgent', userAgent);
        var isBroker = !!~userAgent.indexOf(BrokerFlag);
        if (isBroker)
            return { type: TYPE$1.BROKER, version: '', originVersion: '', originType: TYPE$1.BROKER };
        var isAnjuke = !!~userAgent.indexOf(AnjukeFlag);
        if (isAnjuke) {
            // AJK 安卓 ios，AJKHarmony 鸿蒙，AJKHOUSE 马甲包
            var marchRes = userAgent.match(AnjukeReg) || [];
            var version = marchRes[1] || '';
            return {
                type: TYPE$1.ANJUKE,
                version: version,
                originVersion: '',
                originType: TYPE$1.ANJUKE
            };
        }
        var isTongzhen = !!~userAgent.indexOf(TongzhenFlag);
        if (isTongzhen)
            return {
                type: TYPE$1.WUBA,
                version: '',
                originVersion: userAgent.match(TongzhenReg)[1],
                originType: TYPE$1.TONGZHEN
            };
        var isWuba = !!~userAgent.indexOf(WubaFlag);
        if (isWuba)
            return {
                type: TYPE$1.WUBA,
                version: userAgent.match(WubaReg)[1],
                originVersion: userAgent.match(WubaReg)[1],
                originType: TYPE$1.WUBA
            };
        // 是否来自微信小程序
        var isWeApp = weappReg.test(userAgent);
        if (isWeApp)
            return {
                type: TYPE$1.WEAPP,
                version: (userAgent.match(weappReg) || [])[1] || '',
                originVersion: (userAgent.match(weappReg) || [])[1] || '',
                originType: TYPE$1.WEAPP
            };
        var isBdApp = bdappReg.test(userAgent);
        if (isBdApp)
            return {
                type: TYPE$1.BDAPP,
                version: (userAgent.match(bdappReg) || [])[1] || '',
                originVersion: (userAgent.match(bdappReg) || [])[1] || '',
                originType: TYPE$1.BDAPP
            };
        var isKsApp = ksappReg.test(userAgent);
        if (isKsApp)
            return {
                type: TYPE$1.KSAPP,
                version: (userAgent.match(ksappReg) || [])[1] || '',
                originVersion: (userAgent.match(ksappReg) || [])[1] || '',
                originType: TYPE$1.KSAPP
            };
        var isTtApp = ttappReg.test(userAgent);
        if (isTtApp)
            return {
                type: TYPE$1.TTAPP,
                version: (userAgent.match(ttappReg) || [])[1] || '',
                originVersion: (userAgent.match(ttappReg) || [])[1] || '',
                originType: TYPE$1.TTAPP
            };
        var isZfbApp = zfbappReg.test(userAgent);
        if (isZfbApp)
            return {
                type: TYPE$1.ZFBAPP,
                version: (userAgent.match(zfbappReg) || [])[1] || '',
                originVersion: (userAgent.match(zfbappReg) || [])[1] || '',
                originType: TYPE$1.ZFBAPP
            };
        return { type: TYPE$1.WEB, version: '', originType: TYPE$1.WEB, originVersion: '' };
    }

    var Delegate = /** @class */ (function () {
        function Delegate(proto, target) {
            this.proto = proto;
            this.target = target;
        }
        Delegate.prototype.method = function (name) {
            var proto = this.proto;
            var target = this.target;
            proto[name] = function () {
                return proto[target][name].apply(proto[target], arguments);
            };
            return this;
        };
        Delegate.prototype.auto = function () {
            var proto = this.proto;
            var target = proto[this.target];
            var properties = Object.getOwnPropertyNames(target);
            for (var i = 0; i < properties.length; i++) {
                var property = properties[i];
                var descriptor = Object.getOwnPropertyDescriptor(target, property);
                if (descriptor.hasOwnProperty('value')) {
                    var value = descriptor.value;
                    if (value instanceof Function) {
                        this.method(property);
                    }
                }
            }
        };
        return Delegate;
    }());

    function getPrivacyAccess(callback) {
        var originType = getAppByUA().originType;
        // 如果是58同镇,直接return
        if (originType === TYPE$1.TONGZHEN) {
            callback();
            return;
        }
        var curVer = WBAPP.util.getVersion();
        if (WBAPP.util.compareVersion(curVer, '10.21.0') === -1) {
            // 低版本，不存在该action，执行正常的业务逻辑
            callback();
            return;
        }
        WBAPP.invoke('get_user_info', { key: 'accessmode' }, function (value) {
            if (value === 'guest') {
                WBAPP.invoke('show_privacy_access', {
                    message: '继续使用该功能，请先阅读并授权隐私协议'
                }, function (code) {
                    if (code === '1') {
                        // 已授权，执行正常的业务逻辑
                        callback();
                    }
                    else {
                        // 未授权，提示用户未授权 无法使用该功能
                        WBAPP.action.toast('未授权隐私协议，无法使用该功能');
                    }
                });
            }
            else {
                // 10.21.0灰度包不存在该action 或者 用户已授权 执行正常的业务逻辑
                callback();
            }
        });
    }

    var setTitle = function (title, isDelay) {
        if (isDelay === void 0) { isDelay = true; }
        if (isDelay) {
            setTimeout(function () {
                WBAPP.action.setTitle(title);
            }, 500);
        }
        else {
            WBAPP.action.setTitle(title);
        }
    };
    var setGesture = function (cmd, isDelay) {
        if (isDelay === void 0) { isDelay = true; }
        // 兼容之前cmd类型是字符串
        if (typeof cmd === 'string') {
            if (isDelay) {
                setTimeout(function () {
                    WBAPP.action.toggleGesture(cmd);
                }, 500);
            }
            else {
                WBAPP.action.toggleGesture(cmd);
            }
        }
        else {
            WBAPP.invoke('toggle_gesture', cmd);
        }
    };
    var setProgress = function (_a) {
        var num = _a.num, text = _a.text;
        return WBAPP.invoke('publish_input_progress', {
            progress: num || 0,
            subTitle: text || '完成度0%'
        });
    };
    var setNotification = function (config, callback) {
        var callbackKey = 'getNotificationCallBack';
        window[callbackKey] = function (res) { return callback(res); };
        return WBAPP.invoke('ajk_notification_setting', {
            callback: callbackKey,
            alert: config
        });
    };
    var setStatusBarStyle = function (config) {
        // 如果传入的不是58特殊对象
        if (typeof config !== 'object') {
            return WBAPP.invoke('set_status_bar', {
                mode: config === 0 ? 'dark' : 'light',
                color: ''
            });
        }
        return WBAPP.invoke('set_status_bar', {
            mode: (config && config.mode) || 'dark',
            color: (config && config.color) || '#ffffff'
        });
    };

    var setAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setTitle: setTitle,
        setGesture: setGesture,
        setProgress: setProgress,
        setNotification: setNotification,
        setStatusBarStyle: setStatusBarStyle
    });

    var doLogin = function (callback) {
        return new Promise(function (resolve) {
            WBAPP.action.login(function (result) {
                if (result == 0) {
                    resolve({ info: null, result: result });
                    callback && callback({ info: null, result: result });
                }
                else {
                    resolve({ info: null, result: result });
                    callback && callback({ info: null, result: result });
                }
            });
        });
    };
    function xxwx(value, callback) {
        // 高版本才有这个方法
        // if (list.indexOf('xxwx') > -1) {
        WBAPP.invoke('xxwx', {
            value: value
        }, function (resp) { return callback && callback(JSON.parse(resp)); });
        // }
    }
    /**
     * 在58里面进行加密, 参考https://static.58corp.com/wuxianfe/hybrid/actions/%E8%8E%B7%E5%8F%96%E4%BF%A1%E6%81%AF/xxwx.html#xxwx
     * @param value 加密字段
     * @param callback 回调
     */
    var doXXWX = function (value, callback) {
        if (typeof value !== 'string') {
            try {
                value = JSON.stringify(value);
            }
            catch (e) {
                return;
            }
        }
        // 这个方法暂时有问题，直接调用即可
        // 检测是是否有对应的方法, 这个方法是异步的
        // const actionList = window.alive_action_list;
        // 如果不存在的情况说明是异步，等待回调
        // if (!actionList) {
        // 	WBAPP.ready(() => {
        // 		xxwx(window.alive_action_list, value, callback);
        // 	});
        // 	return;
        // }
        xxwx(value, callback);
    };

    var doAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        doLogin: doLogin,
        doXXWX: doXXWX
    });

    var getUserInfo = function () {
        return new Promise(function (resolve) {
            WBAPP.action.getUserInfo('', function (info) {
                resolve(JSON.parse(info));
            });
        });
    };
    var getLoginState = function () {
        return new Promise(function (resolve) {
            WBAPP.action.isLogin(function (state) {
                resolve(state);
            });
        });
    };
    // 获取状态栏高度
    var getStatusBarHeight = function (callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('get_status_bar', function (data) {
                var resp = JSON.parse(data);
                var mode = resp.mode;
                var height = resp.height;
                // 58app里面10.8.5版本有bug,ios获取到的头部状态栏高度是0;
                height = parseInt(height, 10) || 20;
                if (callback) {
                    callback(height, mode);
                }
                resolve({
                    height: height,
                    mode: mode
                });
            });
        });
    };
    var getCacheLocationInfo = function (callback) {
        var alive_action_list = window.alive_action_list || [];
        if (alive_action_list.indexOf('get_cache_location') >= 0) {
            return new Promise(function (resolve) {
                WBAPP.invoke('get_cache_location', function (resp) {
                    var retResp = JSON.parse(resp);
                    if (callback) {
                        callback(retResp);
                    }
                    return resolve(retResp);
                });
            });
        }
        return new Promise(function (resolve) {
            WBAPP.invoke('get_position', function (lon, lat, source, code) {
                var retResp = {
                    lon: lon,
                    lat: lat,
                    source: source,
                    code: code
                };
                if (callback) {
                    callback(retResp);
                }
                return resolve(retResp);
            });
        });
    };
    var getComplianceLocationInfo = function (params, callback) {
        var alive_action_list = window.alive_action_list || [];
        if (alive_action_list.indexOf('start_compliance_location') >= 0) {
            // 存在该action
            return new Promise(function (resolve) {
                WBAPP.invoke('start_compliance_location', params, function (resp) {
                    var retResp = JSON.parse(resp);
                    if (callback) {
                        callback(retResp);
                    }
                    return resolve(retResp);
                });
            });
        }
        return new Promise(function (resolve) {
            WBAPP.invoke('get_position', function (lon, lat, source, code) {
                var retResp = {
                    lon: lon,
                    lat: lat,
                    source: source,
                    code: code
                };
                if (callback) {
                    callback(retResp);
                }
                return resolve(retResp);
            });
        });
    };
    var getLocationInfo = function (params, callback) {
        if (typeof params === 'function' || !params.compliance_token) {
            return getCacheLocationInfo(callback || params);
        }
        return getComplianceLocationInfo(params, callback);
    };
    var getDeviceData = function (params, callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('get_device_data', params, function (resp) {
                var retResp = JSON.parse(resp);
                if (callback) {
                    callback(retResp);
                }
                return resolve(retResp);
            });
        });
    };

    var getAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getUserInfo: getUserInfo,
        getLoginState: getLoginState,
        getStatusBarHeight: getStatusBarHeight,
        getCacheLocationInfo: getCacheLocationInfo,
        getComplianceLocationInfo: getComplianceLocationInfo,
        getLocationInfo: getLocationInfo,
        getDeviceData: getDeviceData
    });

    var onBack = function (callback) {
        return WBAPP.action.deviceEvent('goback', function () {
            var result = callback();
            // 如果返回false，则调用返回
            if (!result) {
                WBAPP.action.goback();
            }
        });
    };
    var onActive = function (callback) {
        WBAPP.action.deviceEvent('pageshow', callback);
    };
    var onVideoPreview = function (params, callback) {
        return WBAPP.invoke('ajkPreviewVideo', params, function (data) { return callback(JSON.parse(data)); });
    };
    var onMediaPreview = function (params, callback) {
        return WBAPP.invoke('ajk_media_preview', params, function (data) {
            var result = {};
            try {
                console.log(data, '------sucess');
                result = JSON.parse(data);
            }
            catch (error) {
                console.log(data, '------error');
            }
            callback(result);
        });
    };
    // WBAPP.invoke('ajk_media_preview', params, (data: string) => callback(JSON.parse(data)));

    var eventAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        onBack: onBack,
        onActive: onActive,
        onVideoPreview: onVideoPreview,
        onMediaPreview: onMediaPreview
    });

    var goBack = function (params) {
        if (params === void 0) { params = false; }
        return WBAPP.action.goback(params);
    };
    var goWebview = function (_a) {
        var url = _a.url, _b = _a.isFinish, isFinish = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? '' : _c, params = _a.params;
        WBAPP.action.pagetrans('core', {
            pagetype: 'common',
            url: url,
            title: title,
            webType: 'wkWebview',
            isfinish: isFinish,
            settings: {
                hide_title_panel: (params && params.hideTitlePanel) || false,
                contain_status_bar: (params && params.containStatusBar) || true,
                status_bar_mode: (params && params.statusBarMode) || '',
                status_bar_color: (params && params.statusBarColor) || ''
            }
        });
    };

    var goAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        goBack: goBack,
        goWebview: goWebview
    });

    /** @format */
    var platform = (function () {
        var userAgent = navigator.userAgent || '';
        return {
            ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1,
            iPhone: userAgent.indexOf('iPhone') > -1,
            iPad: userAgent.indexOf('iPad') > -1,
            isWx: userAgent.indexOf('MicroMessenger') > -1,
            isMiniProgram: userAgent.indexOf('miniProgram') > -1,
            isWb: userAgent.indexOf('Weibo') > -1,
            isQQ: /qq\/([\d.]+)/i.test(userAgent),
            isQQBrowser: /(qqbrowser)\/([\d.]+)/i.test(userAgent),
            isOriginalChrome: /chrome\/[\d.]+ Mobile Safari\/[\d.]+/i.test(userAgent) &&
                (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1),
            isHuaWeiBrowser: userAgent.toLowerCase().indexOf('huawei') > -1,
            isHarmony: userAgent.toLowerCase().indexOf('harmony') > -1
        };
    });

    var config = {
        prefixes: ['webkit', 'moz', 'ms', 'o']
    };
    /**
     * 获取页面隐藏属性的前缀
     * 如果页面支持 hidden 属性，返回 '' 就行
     * 如果不支持，各个浏览器对 hidden 属性，有自己的实现，不同浏览器不同前缀，遍历看支持哪个
     */
    var getPagePropertyPrefix = function () {
        var prefixes = config.prefixes;
        var correctPrefix;
        if ('hidden' in document)
            return '';
        prefixes.forEach(function (prefix) {
            if (prefix + "Hidden" in document) {
                correctPrefix = prefix;
            }
        });
        return correctPrefix || false;
    };
    /**
     * 判断页面是否隐藏（进入后台）
     */
    var isPageHidden = function () {
        var prefix = getPagePropertyPrefix();
        if (prefix === false)
            return '';
        var hiddenProperty = prefix ? prefix + "Hidden" : 'hidden';
        return document[hiddenProperty];
    };
    /**
     * 获取判断页面 显示|隐藏 状态改变的属性
     */
    var getVisibilityChangeProperty = function () {
        var prefix = getPagePropertyPrefix();
        if (prefix === false)
            return false;
        return prefix + "visibilitychange";
    };
    var createTimer = function (cb, timeout) {
        return setTimeout(function () {
            var hidden = isPageHidden();
            if (!hidden) {
                cb();
            }
        }, timeout);
    };
    /**
     * 检测是否唤端成功
     * @param {function} cb - 唤端失败回调函数
     * @param {number} timeout - 超时默认为3000
     */
    var checkOpen = (function (cb, timeout) {
        if (timeout === void 0) { timeout = 3000; }
        var visibilityChangeProperty = getVisibilityChangeProperty();
        var timer = createTimer(cb, timeout);
        // 针对上面函数返回为boolean或者string做类型保护
        if (visibilityChangeProperty && typeof visibilityChangeProperty === 'string') {
            document.addEventListener(visibilityChangeProperty, function () {
                clearTimeout(timer);
            });
        }
        window.addEventListener('pagehide', function () {
            clearTimeout(timer);
        });
        window.onblur = function () {
            clearTimeout(timer);
        };
        // 这里可能会出现在ios下应用不存在的弹层，也会触发onblur函数，所以手动再检测一次
        if (platform().ios) {
            window.onfocus = function () {
                window.onfocus = null;
                createTimer(cb, 1000);
            };
        }
    });

    var openAuth = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('open_auth_sdk', params, function (res) { return resolve(res); });
        });
    };
    var openFangBenCamera = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('ajkOpenOwnCertificateCameraPage', params, function (res) { return resolve(res); });
        });
    };
    var openSelectPickDialog = function (params) {
        return new Promise(function (resolve) {
            var data = {
                data: params.data,
                callback: '',
                action_handler: ''
            };
            WBAPP.invoke('pub_picker_input', data, function (res) { return resolve(res); });
        });
    };
    var openPhotoSelectCommon = function (config, callback) {
        var callbackKey = 'wubaPhotoCommonCallback';
        window[callbackKey] = callback;
        var configAssign = __assign({}, config);
        configAssign.params.callback = callbackKey;
        return WBAPP.invoke('photo_selector_new', configAssign);
    };
    var openVideoSelect = function (params, callback) {
        if (typeof params === 'object' && params.scenes && typeof callback === 'function') {
            WBAPP.invoke('ajkSelectVideo', params, function (data) { return callback(JSON.parse(data)); });
        }
        else {
            callback = params;
            WBAPP.invoke('ajkSelectVideo', function (data) { return callback(JSON.parse(data)); });
        }
    };
    var openMediaSelect = function (params, callback) {
        WBAPP.invoke('ajk_media_picker', params, function (data) { return callback(JSON.parse(data)); });
    };
    var isWubaNativeLink = function (href) { return !!~href.indexOf('wbmain'); };
    var openWubaApp = function (_a) {
        var _b = _a.href, href = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.openOnly, openOnly = _d === void 0 ? false : _d, _e = _a.downloadOnly, downloadOnly = _e === void 0 ? false : _e, awakeHandler = _a.awakeHandler, downloadHandler = _a.downloadHandler, _f = _a.timeout, timeout = _f === void 0 ? 300 : _f, _g = _a.pid, pid = _g === void 0 ? '751' : _g, params = _a.params;
        var linkParams = {
            url: href || window.location.href,
            title: title || document.title || '58同城',
            webType: 'wkWebview',
            settings: {
                hide_title_panel: (params && params.hideTitlePanel) || false,
                contain_status_bar: (params && params.containStatusBar) || true,
                status_bar_mode: (params && params.statusBarMode) || '',
                status_bar_color: (params && params.statusBarColor) || ''
            }
        };
        // 如果是在微信里面打开的
        if (awakeHandler)
            awakeHandler();
        if (platform().isWx) {
            if (isWubaNativeLink(href)) {
                window.callWbApp('', 'protocol', {
                    jump: href,
                    pid: pid
                });
            }
            else {
                var config = {
                    url: href,
                    title: title,
                    list_name: '',
                    pagetype: 'common',
                    categoryid: '',
                    loadingtype: '0',
                    backtoroot: 'false',
                    domainTips: '',
                    backprotocal: '',
                    webType: 'wkWebview',
                    save_step: false,
                    pullRefresh: false,
                    preRefreshPPU: false,
                    settings: {
                        hide_title_panel: (params && params.hideTitlePanel) || false,
                        contain_status_bar: (params && params.containStatusBar) || true,
                        status_bar_mode: (params && params.statusBarMode) || '',
                        status_bar_color: (params && params.statusBarColor) || ''
                    },
                    userInterfaceStyle: '0'
                };
                var webUrl = "wbmain://jump/core/common?params=" + encodeURIComponent(JSON.stringify(config));
                window.callWbApp('', 'protocol', {
                    jump: webUrl,
                    pid: pid
                });
            }
        }
        else {
            if (!downloadOnly) {
                checkOpen(function () {
                    if (downloadHandler)
                        downloadHandler();
                    window.location.href = "https://apiwireless.58.com/api/redirect/down/" + (pid || 751) + "?pid=" + (pid || 751);
                }, timeout);
                if (isWubaNativeLink(href)) {
                    window.callWbApp('', 'protocol', {
                        jump: href,
                        pid: pid
                    });
                }
                else {
                    var url = "wbmain://jump/core/common?params=" + encodeURIComponent(JSON.stringify(linkParams));
                    window.callWbApp('', 'protocol', {
                        jump: url,
                        pid: pid
                    });
                }
            }
            if (openOnly)
                return true;
            if (downloadOnly)
                window.location.href = "https://apiwireless.58.com/api/redirect/down/" + (pid || 751) + "?pid=" + (pid || 751);
        }
    };

    var openAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        openAuth: openAuth,
        openFangBenCamera: openFangBenCamera,
        openSelectPickDialog: openSelectPickDialog,
        openPhotoSelectCommon: openPhotoSelectCommon,
        openVideoSelect: openVideoSelect,
        openMediaSelect: openMediaSelect,
        openWubaApp: openWubaApp
    });

    var buildShareContent = function (params) {
        if (Array.isArray(params))
            return params;
        params = typeof params === 'string' ? JSON.parse(params) : params;
        var platforms = params.platform || ['WEIXIN', 'FRIENDS', 'SINA', 'QQ'];
        var results = [];
        platforms.forEach(function (item) {
            var newItem = {
                shareto: item,
                url: params.url,
                title: params.title,
                content: params.description,
                img_url: params.image || ''
            };
            if (params.param && params.param[item]) {
                newItem = __assign(__assign({}, newItem), params.param[item]);
            }
            results.push(newItem);
        });
        return results;
    };
    var getImgPathFromData = function (item) {
        var host = item.host, hash = item.hash, width = item.width, height = item.height;
        return "https://pic" + host + ".ajkimg.com/display/hj/" + hash + "/" + width + "x" + height + ".jpg";
    };
    var getImgAllFromData = function (item) {
        var host = item.host, hash = item.hash, width = item.width, height = item.height;
        return __assign(__assign({}, item), { path: "https://pic" + host + ".ajkimg.com/display/hj/" + hash + "/" + width + "x" + height + ".jpg" });
    };
    var buildPhoto = function (array, allBack) {
        if (allBack === void 0) { allBack = false; }
        // 转换成和安居客一样的数据格式
        var imgs = [];
        array.forEach(function (item) {
            if (allBack) {
                imgs.push(getImgAllFromData(item));
            }
            else {
                imgs.push(getImgPathFromData(item));
            }
        });
        return imgs;
    };

    var Hybrid58 = /** @class */ (function () {
        function Hybrid58() {
            this.ready = function (callback) {
                WBAPP.ready(function () {
                    if (callback)
                        callback();
                });
            };
            this.callbacks = {};
            this.callbackKeys = {
                RightHandler: '58-right-callback',
                LoginHandler: '58-login-callback',
                CollectionHandler: '58-collection-callback',
                ShareHandler: '58-share-callback',
                PhotoCallback: '58-photo-callback'
            };
            this.shareConfig = { title: '58分享', description: '58分享描述', url: '' };
            this.navigatorConfig = [];
            this.setAction = setAction;
            this.getAction = getAction;
            this.doAction = doAction;
            this.eventAction = eventAction;
            this.goAction = goAction;
            this.openAction = openAction;
            new Delegate(this, 'setAction').auto();
            new Delegate(this, 'getAction').auto();
            new Delegate(this, 'doAction').auto();
            new Delegate(this, 'eventAction').auto();
            new Delegate(this, 'goAction').auto();
            new Delegate(this, 'openAction').auto();
        }
        Hybrid58.prototype.init = function () {
            if (typeof WBAPP !== 'undefined') {
                WBAPP.invoke('ajk_log', {
                    jump_log: {
                        action_code: '1954',
                        note: { url: location.href }
                    }
                });
            }
        };
        Hybrid58.prototype.setShare = function (config, callback) {
            console.log('setShare', this);
            this.navigatorConfig[0] = { key: 'share', txt: '分享', icon: 'share' };
            this.shareConfig = config;
            this.callbacks[this.callbackKeys.ShareHandler] = function () {
                WBAPP.action.share(buildShareContent(config), function () {
                    getPrivacyAccess(callback);
                });
            };
            return this.setNavigatorRightText();
        };
        Hybrid58.prototype.doShare = function (config) {
            if (config === void 0) { config = this.shareConfig; }
            return WBAPP.action.share(buildShareContent(config), function () { });
        };
        Hybrid58.prototype.setRightText = function (title, textColor) {
            if (textColor === void 0) { textColor = '#00c34b'; }
            this.navigatorConfig[2] = { key: 'txt', txt: title, txtcolor: textColor };
            return this.setNavigatorRightText('vertical');
        };
        Hybrid58.prototype.onRightTextClick = function (callback) {
            this.callbacks[this.callbackKeys.RightHandler] = callback;
        };
        Hybrid58.prototype.setCollection = function (_a) {
            var text = _a.text, is_collect = _a.is_collect;
            console.log(is_collect);
            this.navigatorConfig[1] = { key: 'collection', txt: text || '收藏', icon: is_collect ? 'star-full' : 'star' };
            return this.setNavigatorRightText();
        };
        Hybrid58.prototype.onCollectionClick = function (callback) {
            this.callbacks[this.callbackKeys.CollectionHandler] = callback;
        };
        Hybrid58.prototype.openPhotoSelect = function (params) {
            var _this = this;
            var allBack = !!params.allBack || false;
            params.maxNum = "" + params.maxNum;
            params.hadNum = "" + params.hadNum;
            return WBAPP.invoke('zx_talk_upload_images', __assign({}, params), function (data) {
                var result = typeof data === 'string' ? JSON.parse(data) : data;
                _this.callbacks[_this.callbackKeys.PhotoCallback](buildPhoto(result, allBack));
            });
        };
        Hybrid58.prototype.onPhotoSelect = function (callback) {
            this.callbacks[this.callbackKeys.PhotoCallback] = callback;
        };
        Hybrid58.prototype.getWebviewUrl = function (_a) {
            var url = _a.url, title = _a.title, _b = _a.isFinish, isFinish = _b === void 0 ? false : _b, params = _a.params;
            var config = {
                url: url || location.href,
                title: title || document.title || '58同城',
                list_name: '',
                pagetype: 'common',
                categoryid: '',
                loadingtype: '0',
                backtoroot: 'false',
                domainTips: '',
                backprotocal: '',
                webType: 'wkWebview',
                save_step: false,
                pullRefresh: false,
                preRefreshPPU: false,
                settings: {
                    hide_title_panel: (params && params.hideTitlePanel) || false,
                    contain_status_bar: (params && params.containStatusBar) || true,
                    status_bar_mode: (params && params.statusBarMode) || '',
                    status_bar_color: (params && params.statusBarColor) || ''
                }
            };
            var href = "wbmain://jump/core/common?params=" + encodeURIComponent(JSON.stringify(config)) + "&isFinish=" + isFinish;
            return href;
        };
        Hybrid58.prototype.setNavigatorRightText = function (position) {
            var _this = this;
            if (position === void 0) { position = 'horizontal'; }
            var config = this.navigatorConfig;
            var result = [];
            config.forEach(function (item) {
                if (typeof item === 'object') {
                    result.push(item);
                }
            });
            return WBAPP.action.extendBtn(result, function (key) {
                if (key === 'share') {
                    _this.callbacks[_this.callbackKeys.ShareHandler]();
                    return;
                }
                if (key === 'collection') {
                    _this.callbacks[_this.callbackKeys.CollectionHandler]();
                    return;
                }
                if (key === 'txt') {
                    _this.callbacks[_this.callbackKeys.RightHandler]();
                }
            }, position);
        };
        return Hybrid58;
    }());

    // 将不同的方法暴露出去
    var HybridTongzhen = /** @class */ (function (_super) {
        __extends(HybridTongzhen, _super);
        function HybridTongzhen() {
            var _this = this;
            console.log('tongzheng struct');
            _this = _super.call(this) || this;
            return _this;
        }
        return HybridTongzhen;
    }(Hybrid58));

    var buildShareContent$1 = function (params) {
        var defaultShareImg = 'https://pages.anjukestatic.com/usersite/touch/img/global/defaultImg/share_img.png';
        // 增加对数组的支持
        if (params instanceof Array) {
            return JSON.stringify(params);
        }
        params = typeof params === 'object' ? params : JSON.parse(params);
        var platform = typeof params.platform === 'undefined' ? ['wxhy', 'pyq', 'sinawb'] : params.platform;
        var length = platform.length;
        var data = [];
        for (var i = 0; i < length; i++) {
            var config = JSON.parse(JSON.stringify(params));
            config.pm = platform[i];
            // 设置默认图片，否则将无法吊起分享
            config.image = config.image || defaultShareImg;
            if (platform[i] === 'wxmp') {
                // shareConfig.url = '/page/outpage/pages/home/web/index?web_url=' + encodeURIComponent(this.article.share.url || window.location.href)
                config.param = params.param;
            }
            if (platform[i] === 'weiliao') {
                config.title = (params.weiliao && params.weiliao.title) || params.title;
                config.url = (params.weiliao && params.weiliao.url) || params.url;
            }
            else {
                delete config.weiliao;
            }
            data.push(config);
        }
        return JSON.stringify(data);
    };

    var setTitle$1 = function (title, isDelay) {
        if (isDelay === void 0) { isDelay = false; }
        if (isDelay) {
            setTimeout(function () {
                WBAPP.invoke('setAjkTitle', { title: title });
            }, 500);
        }
        else {
            WBAPP.invoke('setAjkTitle', { title: title });
        }
    };
    var setShare = function (config, callback, isDelay) {
        if (isDelay === void 0) { isDelay = true; }
        window.getShareContents = function getShareContents() { };
        if (callback && typeof callback === 'function') {
            window.shareCallBack = function () {
                callback('0');
            };
            window.shareCallBackFail = function () {
                callback('1');
            };
        }
        if (isDelay) {
            setTimeout(function () {
                WBAPP.invoke('ajkSetShareContents', {
                    data: Array.isArray(config) ? JSON.stringify(config) : buildShareContent$1(config)
                });
            }, 500);
        }
        else {
            WBAPP.invoke('ajkSetShareContents', {
                data: Array.isArray(config) ? JSON.stringify(config) : buildShareContent$1(config)
            });
        }
    };
    var setCollection = function (config) { return WBAPP.invoke('setCollectContents', config); };
    // 取消滚动渐变 1:禁止 0:开启
    var setTransparentDisabled = function (value, callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('setTransparentDisabled', { value: value }, function (data) {
                callback && callback(data);
                resolve(data);
            });
        });
    };
    var setConfigTitleData = function (config, isDelay) {
        if (isDelay === void 0) { isDelay = true; }
        var invoke = function () {
            var dpr = 1;
            if (platform().android) {
                dpr = window.devicePixelRatio;
            }
            config.scrollHeight = "" + Math.floor(Number(config.scrollHeight) * dpr);
            return WBAPP.invoke('configTitleData', { data: config });
        };
        if (isDelay) {
            setTimeout(function () { return invoke(); }, 500);
        }
        else {
            invoke();
        }
    };
    // 设置头部的透明度
    var setTitleAlpha = function (alpha) { return WBAPP.invoke('setTitleAlpha', { alpha: alpha }); };
    // 设置类似电量这些图标的颜色 0 黑色 1白色
    var setStatusBarStyle$1 = function (value) { return WBAPP.invoke('setStatusBarStyle', { value: value }); };
    var setRightText = function (data, isDelay) {
        if (isDelay === void 0) { isDelay = true; }
        if (isDelay) {
            setTimeout(function () {
                WBAPP.invoke('anjuke_native_header_right_btn_text', { data: data }, function () { });
            }, 500);
        }
        else {
            WBAPP.invoke('anjuke_native_header_right_btn_text', { data: data }, function () { });
        }
    };
    // 不知道这个功能的用处，但是老业务有地方在用
    var setListDotHide = function () { return WBAPP.invoke('ajkHideSubscribeListDot', {}); };
    var setGesture$1 = function (cmd, isDelay) {
        if (isDelay === void 0) { isDelay = true; }
        // 兼容之前cmd类型是字符串
        if (typeof cmd === 'string') {
            if (isDelay) {
                setTimeout(function () {
                    WBAPP.action.toggleGesture(cmd);
                }, 500);
            }
            else {
                WBAPP.action.toggleGesture(cmd);
            }
        }
        else {
            WBAPP.invoke('toggle_gesture', cmd);
        }
    };
    var setNotification$1 = function (config, callback) {
        var callbackKey = 'getNotificationCallBack';
        window[callbackKey] = function (res) { return callback(res); };
        return WBAPP.invoke('ajk_notification_setting', {
            callback: callbackKey,
            alert: config
        });
    };
    var setHideHeaderRightButton = function () {
        WBAPP.invoke('anjuke_hide_header_right_btn');
    };

    var setAction$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setTitle: setTitle$1,
        setShare: setShare,
        setCollection: setCollection,
        setTransparentDisabled: setTransparentDisabled,
        setConfigTitleData: setConfigTitleData,
        setTitleAlpha: setTitleAlpha,
        setStatusBarStyle: setStatusBarStyle$1,
        setRightText: setRightText,
        setListDotHide: setListDotHide,
        setGesture: setGesture$1,
        setNotification: setNotification$1,
        setHideHeaderRightButton: setHideHeaderRightButton
    });

    var getUserInfo$1 = function () {
        return new Promise(function (resolve) {
            WBAPP.invoke('ajkGetUserInfo', function (info) {
                resolve(JSON.parse(info));
            });
        });
    };
    var getLoginState$1 = function () {
        return new Promise(function (resolve) {
            WBAPP.action.isLogin(function (state) {
                resolve(state);
            });
        });
    };
    // 获取状态栏和导航栏高度
    var getTitleBarHeight = function (callback) {
        var dpr = 1;
        if (platform().android) {
            dpr = window.devicePixelRatio;
        }
        return new Promise(function (resolve) {
            WBAPP.invoke('getTitleBarHeight', function (data) {
                callback && typeof callback === 'function' && callback(data / dpr);
                resolve(data / dpr);
            });
        });
    };
    // 获取状态栏高度
    var getStatusBarHeight$1 = function (callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('get_status_bar', function (data) {
                var resp = JSON.parse(data);
                var mode = resp.mode;
                var height = resp.height;
                // 58app里面10.8.5版本有bug,ios获取到的头部状态栏高度是0;安居客可能也有,未测试过
                height = parseInt(height, 10) || 20;
                callback && typeof callback === 'function' && callback(height, mode);
                resolve({
                    height: height,
                    mode: mode
                });
            });
        });
    };
    // 获取登录模式 0:未授权隐私协议 1:已授权隐私协议
    var getPrivacyAccess$1 = function (callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('get_privacy_access', function (data) {
                callback && typeof callback === 'function' && callback(data);
                resolve(data);
            });
        });
    };
    // export const getLocationInfo = callback => {
    // return new Promise(resolve => {
    // 	WBAPP.invoke('getLocationInfo', data => {
    // 		const result = JSON.parse(data);
    // 		// 单独处理缓存信息
    // 		if (Object.prototype.hasOwnProperty.call(result, 'is_granted') && !result.is_granted) {
    // 			// 如果有is_granted属性并且为false, 此时拿到的是缓存的值，置空
    // 			result.lat = '';
    // 			result.lon = '';
    // 		}
    // 		if (callback && typeof callback === 'function') {
    // 			callback(result);
    // 		}
    // 		return resolve(result);
    // 	});
    // });
    // };
    var getCacheLocationInfo$1 = function (callback) {
        var alive_action_list = window.alive_action_list || [];
        if (alive_action_list.indexOf('get_cache_location') >= 0) {
            return new Promise(function (resolve) {
                WBAPP.invoke('get_cache_location', function (resp) {
                    var retResp = JSON.parse(resp);
                    if (callback) {
                        callback(retResp);
                    }
                    return resolve(retResp);
                });
            });
        }
        return new Promise(function (resolve) {
            WBAPP.invoke('getLocationInfo', function (data) {
                var result = JSON.parse(data);
                // 单独处理缓存信息
                if (Object.prototype.hasOwnProperty.call(result, 'is_granted') && !result.is_granted) {
                    // 如果有is_granted属性并且为false, 此时拿到的是缓存的值，置空
                    result.lat = '';
                    result.lon = '';
                }
                if (callback && typeof callback === 'function') {
                    callback(result);
                }
                return resolve(result);
            });
        });
    };
    var getComplianceLocationInfo$1 = function (params, callback) {
        var alive_action_list = window.alive_action_list || [];
        if (alive_action_list.indexOf('start_compliance_location') >= 0) {
            // 存在该action
            return new Promise(function (resolve) {
                WBAPP.invoke('start_compliance_location', params, function (resp) {
                    var retResp = JSON.parse(resp);
                    if (callback) {
                        callback(retResp);
                    }
                    return resolve(retResp);
                });
            });
        }
        return new Promise(function (resolve) {
            WBAPP.invoke('getLocationInfo', function (data) {
                var result = JSON.parse(data);
                // 单独处理缓存信息
                if (Object.prototype.hasOwnProperty.call(result, 'is_granted') && !result.is_granted) {
                    // 如果有is_granted属性并且为false, 此时拿到的是缓存的值，置空
                    result.lat = '';
                    result.lon = '';
                }
                if (callback && typeof callback === 'function') {
                    callback(result);
                }
                return resolve(result);
            });
        });
    };
    var getLocationInfo$1 = function (params, callback) {
        if (typeof params === 'function' || !params.compliance_token) {
            return getCacheLocationInfo$1(callback || params);
        }
        return getComplianceLocationInfo$1(params, callback);
    };
    var getDeviceData$1 = function (params, callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('get_device_data', params, function (resp) {
                var retResp = JSON.parse(resp);
                if (callback) {
                    callback(retResp);
                }
                return resolve(retResp);
            });
        });
    };

    var getAction$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getUserInfo: getUserInfo$1,
        getLoginState: getLoginState$1,
        getTitleBarHeight: getTitleBarHeight,
        getStatusBarHeight: getStatusBarHeight$1,
        getPrivacyAccess: getPrivacyAccess$1,
        getCacheLocationInfo: getCacheLocationInfo$1,
        getComplianceLocationInfo: getComplianceLocationInfo$1,
        getLocationInfo: getLocationInfo$1,
        getDeviceData: getDeviceData$1
    });

    var onRightTextClick = function (callback) {
        window.anjuke_native_header_right_btn_text_click = callback;
    };
    var onBack$1 = function (callback) {
        window.checkAjkAppUseGoBack = callback;
    };
    var onActive$1 = function (callback) {
        window.ajkDidBecomeActive = callback;
    };
    var onUploadStatusUpdate = function (callback) {
        window.onUploadStatusUpdate = callback;
    };
    var onAppSendOwnerPushCertificateBase64 = function (callback) {
        window.appSendOwnerPushCertificateBase64 = callback;
    };
    var onPayResult = function (callback) {
        window.onPayResult = callback;
    };
    var onPhotoSelect = function (callback) {
        window.appSendBase64 = function (data) {
            var result = typeof data === 'string' ? JSON.parse(data) : data;
            callback(result);
        };
    };
    var onMediaPreview$1 = function (params, callback) {
        return WBAPP.invoke('ajk_media_preview', params, function (data) {
            var result = {};
            try {
                console.log(data, '------sucess');
                result = JSON.parse(data);
            }
            catch (error) {
                console.log(data, '------error');
            }
            callback(result);
        });
    };
    var onSaveImage = function (params) {
        if (platform().android)
            return;
        WBAPP.invoke('official_account_save_image', params);
    };
    var onVideoPreview$1 = function (params, callback) {
        return WBAPP.invoke('ajkPreviewVideo', params, function (data) { return callback(JSON.parse(data)); });
    };

    var eventAction$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        onRightTextClick: onRightTextClick,
        onBack: onBack$1,
        onActive: onActive$1,
        onUploadStatusUpdate: onUploadStatusUpdate,
        onAppSendOwnerPushCertificateBase64: onAppSendOwnerPushCertificateBase64,
        onPayResult: onPayResult,
        onPhotoSelect: onPhotoSelect,
        onMediaPreview: onMediaPreview$1,
        onSaveImage: onSaveImage,
        onVideoPreview: onVideoPreview$1
    });

    var doShare = function (params) { return WBAPP.invoke('shareButtonClick', params); };
    var doLogin$1 = function (callback) {
        return new Promise(function (resolve) {
            WBAPP.action.login(function (result) {
                if (result == 0) {
                    WBAPP.invoke('ajkGetUserInfo', function (info) {
                        resolve({ info: JSON.parse(info), result: result });
                        callback && callback({ info: JSON.parse(info), result: result });
                    });
                }
                else {
                    resolve({ info: null, result: 1 });
                    callback && callback({ info: null, result: 1 });
                }
            });
        });
    };
    var doPhoneCall = function (phone) { return WBAPP.invoke('telTo', { number: phone.toString() }); };
    var doPay = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('pay', { data: params }, function (res) { return resolve(res); });
        });
    };
    var doAuthorize = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('tryAuthorize', { BusinessId: params.businessId }, function (res) { return resolve(res); });
        });
    };
    var doLoginDialog = function (params, callback) {
        return new Promise(function (resolve) {
            WBAPP.invoke('login_dialog', params, function (state) {
                if (callback) {
                    callback(state);
                }
                return resolve(state);
            });
        });
    };

    var doAction$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        doShare: doShare,
        doLogin: doLogin$1,
        doPhoneCall: doPhoneCall,
        doPay: doPay,
        doAuthorize: doAuthorize,
        doLoginDialog: doLoginDialog
    });

    var goBack$1 = function (params) {
        if (params === void 0) { params = false; }
        var length = history.length;
        if (length > 1 && !params) {
            // 如果webview有其它路径
            if (platform().ios) {
                WBAPP.action.goback();
            }
            else {
                history.back();
            }
        }
        else {
            return WBAPP.action.goback(true);
        }
    };
    var goHome = function () {
        WBAPP.invoke('pagetrans', { protocol: 'openanjuke://app.anjuke.com/m/app/main_tab_page' });
    };

    var goAction$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        goBack: goBack$1,
        goHome: goHome
    });

    var config$1 = {
        spiderList: ['bot', 'spider', 'yahoo'],
        semList: {
            'baidu.com': {
                refer: ['baidu.com']
            },
            'sogou.com': {
                refer: ['bill_cpc']
            },
            'so.com': {
                params: ['pi']
            },
            'haosou.com': {
                params: ['pi']
            },
            '360.cn': {
                params: ['pi']
            },
            'sm.cn': {
                params: ['pi']
            }
        },
        prefixes: ['webkit', 'moz', 'ms', 'o'],
        appInfo: {
            iosUrl: 'https://itunes.apple.com/cn/app/id415606289',
            iosHighUrl: 'https://mlink.anjuke.com/?',
            androidUrl: '//android.anjuke.com/download/anjuke/',
            pm: 'b318',
            version: '11.8.2',
            action: 'download',
            weixinUrl: '//a.app.qq.com/o/simple.jsp?pkgname=com.anjuke.android.app&g_f=991653&ipm=touch',
            harmonyStoreUrl: 'store://appgallery.huawei.com/app/detail?id=com.anjuke.home'
        },
        reg: {
            schemeHeader: /^(openanjuke:\/\/)/,
            schemeHeader2: /^openanjuke/,
            m: /^([a-zA-Z0-9\-](\.)?)+(\.anjuke\.(com|test))$/
        }
    };

    /** @format */
    var getURLParameter = function (name) {
        return (decodeURIComponent((new RegExp("[?|&]" + name + "=([^&;]+?)(&|#|;|$)").exec(window.location.search) || [null, ''])[1].replace(/\+/g, '%20')) || '');
    };

    /**
     * 判断是不是sem
     */
    var isSem = function (semList) {
        var refer = window.document.referrer.toLowerCase();
        var keys = Object.keys;
        var semListArr = keys(semList);
        var _loop_1 = function (i) {
            var k = semListArr[i];
            var semV = semList[k];
            if (refer.indexOf(k)) {
                if (semV.refer) {
                    return { value: keys(semV.refer).every(function (ik) { return !refer.indexOf(semV.refer[ik]); }) };
                }
                if (semV.params) {
                    return { value: keys(semV.params).every(function (jk) { return !getURLParameter(semV.params[jk]); }) };
                }
                return { value: true };
            }
        };
        for (var i = 0; i < semListArr.length; i += 1) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    };
    /**
     * 判断是不是爬虫
     */
    var isSpider = function (spiderList) {
        var ua = window.navigator.userAgent.toLowerCase();
        return Object.values(spiderList).some(function (value) { return ua.indexOf(value) > -1; });
    };
    var isSemOrSpier = function () {
        var spiderList = config$1.spiderList, semList = config$1.semList;
        if (isSpider(spiderList) || isSem(semList))
            return true;
        return false;
    };

    function compareVersion(v1, v2) {
        if (!v1 || !v2) {
            return -1;
        }
        var currVersion = v1.split('.');
        var currLength = currVersion.length;
        var minVersion = v2.split('.');
        var minLength = minVersion.length;
        var length = currLength > minLength ? currLength : minLength;
        var currValue;
        var minValue;
        for (var i = 0; i < length; i++) {
            // 进行数字转换，否则 ‘10’ < '7'
            currValue = Number(currVersion[i]);
            minValue = Number(minVersion[i]);
            if (currValue > 0 && minValue > 0) {
                if (currValue < minValue) {
                    return -1;
                }
                if (currValue > minValue) {
                    return 1;
                }
                if (i === length - 1) {
                    return 0;
                }
                continue;
            }
            else if (currLength > i && minLength < i) {
                return currValue > 0 ? 1 : 0;
            }
            else if (currLength < i && minLength > i) {
                return minValue > 0 ? -1 : 0;
            }
            else {
                return 0;
            }
        }
    }
    var getWeChatVersion = function () {
        var version = window.navigator.appVersion.match(/micromessenger\/(\d+\.\d+\.\d+)/i);
        return version[1];
    };

    /**
     * 获取页面隐藏属性的前缀
     * 如果页面支持 hidden 属性，返回 '' 就行
     * 如果不支持，各个浏览器对 hidden 属性，有自己的实现，不同浏览器不同前缀，遍历看支持哪个
     */
    var getPagePropertyPrefix$1 = function () {
        var prefixes = config$1.prefixes;
        var correctPrefix;
        if ('hidden' in document)
            return '';
        prefixes.forEach(function (prefix) {
            if (prefix + "Hidden" in document) {
                correctPrefix = prefix;
            }
        });
        return correctPrefix || false;
    };
    /**
     * 判断页面是否隐藏（进入后台）
     */
    var isPageHidden$1 = function () {
        var prefix = getPagePropertyPrefix$1();
        if (prefix === false)
            return '';
        var hiddenProperty = prefix ? prefix + "Hidden" : 'hidden';
        return document[hiddenProperty];
    };
    /**
     * 获取判断页面 显示|隐藏 状态改变的属性
     */
    var getVisibilityChangeProperty$1 = function () {
        var prefix = getPagePropertyPrefix$1();
        if (prefix === false)
            return false;
        return prefix + "visibilitychange";
    };
    var createTimer$1 = function (cb, timeout) {
        return setTimeout(function () {
            var hidden = isPageHidden$1();
            if (!hidden) {
                cb();
            }
        }, timeout);
    };
    /**
     * 检测是否唤端成功
     * @param {function} cb - 唤端失败回调函数
     * @param {number} timeout - 超时默认为3000
     */
    var checkOpen$1 = function (cb, timeout) {
        if (timeout === void 0) { timeout = 3000; }
        var visibilityChangeProperty = getVisibilityChangeProperty$1();
        var timer = createTimer$1(cb, timeout);
        // 针对上面函数返回为boolean或者string做类型保护
        if (visibilityChangeProperty && typeof visibilityChangeProperty === 'string') {
            document.addEventListener(visibilityChangeProperty, function () {
                clearTimeout(timer);
            });
        }
        window.addEventListener('pagehide', function () {
            clearTimeout(timer);
        });
        window.onblur = function () {
            clearTimeout(timer);
        };
        // 这里可能会出现在ios下应用不存在的弹层，也会触发onblur函数，所以手动再检测一次
        if (platform().ios) {
            window.onfocus = function () {
                window.onfocus = null;
                timer = createTimer$1(cb, 3000);
            };
        }
    };
    /**
     * 通过 A 标签唤起
     * @param {string}} [url] - 需要打开的地址
     */
    var evokeByTagA = function (url) {
        var tagA = document.createElement('a');
        tagA.setAttribute('href', url);
        tagA.style.display = 'none';
        document.body.appendChild(tagA);
        tagA.click();
    };
    /**
     * 通过 top.location.href 跳转
     * 使用 top 是因为在 qq 中打开的页面不属于顶级页面(iframe级别)
     * 自身 url 变更无法触动唤端操作
     * @param {string}} [url] - 需要打开的地址
     */
    var evokeByLocationTop = function (url) {
        window.top.location.href = url;
    };
    var evokeByLocation = function (url) {
        window.location.href = url;
    };
    var evokeByWxIOS = function (url) {
        var encodeScheme = encodeURIComponent(url);
        if (encodeScheme) {
            evokeByLocation(config$1.appInfo.weixinUrl + "&ios_schema=" + encodeScheme);
        }
        else {
            evokeByLocation(config$1.appInfo.weixinUrl);
        }
    };
    var evokeByWxAndroid = function (url) {
        var encodeScheme = encodeURIComponent(url);
        if (encodeScheme) {
            evokeByLocation(config$1.appInfo.weixinUrl + "&android_schema=" + encodeScheme);
        }
        else {
            evokeByLocation(config$1.appInfo.weixinUrl);
        }
    };
    var evokeByUniversalLink = function (url) {
        var encodeScheme = encodeURIComponent(url);
        evokeByLocation(config$1.appInfo.iosHighUrl + "scheme=" + encodeScheme);
    };

    var checkIsLink = function (href) { return config$1.reg.schemeHeader.test(href); };
    var checkIsUrl = function (href) {
        if (/^http(s)?:\/\//.test(href)) {
            var host = href.replace(/^http(s)?:\/\//, '').split('/');
            return config$1.reg.m.test(host[0]);
        }
        return false;
    };
    var buildUrl = function (href, params) {
        return "openanjuke://jump/core/common?params=" + encodeURIComponent(JSON.stringify({
            url: href,
            title: '',
            list_name: '',
            ajk_type: '0',
            pagetype: 'common',
            categoryid: '',
            loadingtype: '0',
            backtoroot: 'false',
            domainTips: '',
            backprotocal: '',
            webType: '',
            save_step: false,
            pullRefresh: false,
            settings: {
                hide_title_panel: (params && params.hideTitlePanel) || false,
                contain_status_bar: (params && params.containStatusBar) || true,
                status_bar_mode: (params && params.statusBarMode) || '',
                status_bar_color: (params && params.statusBarColor) || ''
            }
        })) + "&isFinish=false&needLogin=false&isBackToMain=false&isSlideinBottom=false&isNoAnimated=false";
    };
    var buildScheme = function (href, params) {
        var link = '';
        // 这里可能出现二次encode情况，所以解码两次
        if (!config$1.reg.schemeHeader.test(href) && config$1.reg.schemeHeader2.test(href)) {
            href = decodeURIComponent(href || '');
        }
        if (checkIsUrl(href)) {
            link = buildUrl(href, params);
        }
        else if (checkIsLink(href)) {
            link = href;
        }
        return link;
    };
    var downloadApp = function (scheme, android) {
        if (android === void 0) { android = {
            version: '',
            pm: ''
        }; }
        return function () {
            if (platform().isWx) {
                if (platform().ios) {
                    evokeByWxIOS(scheme);
                }
                else {
                    evokeByWxAndroid(scheme);
                }
            }
            else if (platform().ios) {
                evokeByLocation(config$1.appInfo.iosUrl);
            }
            else {
                var pm = android.pm || config$1.appInfo.pm;
                var androidLink = "" + config$1.appInfo.androidUrl + pm;
                if (platform().isHarmony) {
                    evokeByLocation(config$1.appInfo.harmonyStoreUrl);
                }
                else if (platform().isHuaWeiBrowser) {
                    evokeByTagA(androidLink);
                }
                else {
                    evokeByLocation(androidLink);
                }
            }
            return true;
        };
    };

    var openOwnCertificateCameraPage = function (params) { return WBAPP.invoke('openOwnCertificateCameraPage', { data: params }); };
    var openAccountBinding = function (params) { return WBAPP.invoke('ajkWUBAAuth', params); };
    var openCommunitySearch = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('openCommunitySearch', params, function (res) { return resolve(res); });
        });
    };
    var openInputDialog = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('openInputDialog', params, function (res) { return resolve(res); });
        });
    };
    var openSelectPickDialog$1 = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('pub_picker_input', params, function (res) { return resolve(JSON.parse(res)); });
        });
    };
    var openFaceCertify = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('ajkOpenFaceCertify', params, function (res) { return resolve(res); });
        });
    };
    /**
     * 58房本相机
     */
    var openWubaFBPhoto = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('_wuba_fangben_upload_component', params, function (res) { return resolve(res); });
        });
    };
    var openAuth$1 = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('open_auth_sdk', params, function (res) { return resolve(res); });
        });
    };
    var openIOSAppEvaluation = function (params) { return WBAPP.invoke('openIOSAppEvaluation', params); };
    var openResource = function (params) { return WBAPP.invoke('ajkOpenResource', params); };
    var openFangBenCamera$1 = function (params) {
        return new Promise(function (resolve) {
            WBAPP.invoke('ajkOpenOwnCertificateCameraPage', params, function (res) { return resolve(res); });
        });
    };
    var openPhotoSelect = function (params) { return WBAPP.invoke('showPickDialog', params); };
    var openMediaSelect$1 = function (params, callback) {
        WBAPP.invoke('ajk_media_picker', params, function (data) { return callback(JSON.parse(data)); });
    };
    var openVideoSelect$1 = function (params, callback) {
        if (typeof params === 'object' && params.scenes && typeof callback === 'function') {
            WBAPP.invoke('ajkSelectVideo', params, function (data) { return callback(JSON.parse(data)); });
        }
        else {
            callback = params;
            WBAPP.invoke('ajkSelectVideo', function (data) { return callback(JSON.parse(data)); });
        }
    };
    var openAjkApp = function (_a, log) {
        var _b = _a.href, href = _b === void 0 ? '' : _b, _c = _a.downloadOnly, downloadOnly = _c === void 0 ? false : _c, _d = _a.openOnly, openOnly = _d === void 0 ? false : _d, _e = _a.timeout, timeout = _e === void 0 ? 2000 : _e, urlErrorHandler = _a.urlErrorHandler, awakeHandler = _a.awakeHandler, downloadHandler = _a.downloadHandler, android = _a.android, params = _a.params, _f = _a.allowOldWX, allowOldWX = _f === void 0 ? false : _f;
        var checkOpenFall = null;
        var platformInVoked = platform();
        if (isSemOrSpier()) {
            log('openApp触发SEM爬虫不调用');
            return false;
        }
        var schemeUrl = href || '';
        if (platformInVoked.isHarmony && !platformInVoked.android) {
            // 鸿蒙先统一跳转到首页
            schemeUrl = 'openanjuke://app.anjuke.com/home/';
        }
        var scheme = buildScheme(schemeUrl, params);
        if (!scheme && !downloadOnly) {
            log('urlBuild失败');
            urlErrorHandler && urlErrorHandler();
            return false;
        }
        if (!downloadOnly) {
            awakeHandler && awakeHandler();
            if (platformInVoked.ios) {
                // 近期ios版本qq禁止了scheme和universalLink唤起app，安卓不受影响 - 18年12月23日
                // ios qq浏览器禁止了scheme和universalLink - 2019年5月1日
                // ios 微信自 7.0.5 版本放开了 Universal Link 的限制
                if (platformInVoked.isWx && compareVersion(getWeChatVersion(), '7.0.5') >= 0) {
                    if (allowOldWX) {
                        evokeByWxIOS(scheme);
                    }
                    else {
                        evokeByUniversalLink(scheme);
                    }
                }
                else if (platformInVoked.isWx) {
                    evokeByWxIOS(scheme);
                }
                else if (platformInVoked.isQQ || platformInVoked.isQQBrowser) {
                    evokeByLocationTop(config$1.appInfo.iosUrl);
                    downloadHandler && downloadHandler();
                }
                else {
                    evokeByLocation(scheme);
                    checkOpenFall = checkOpen$1;
                }
            }
            else if (platformInVoked.android) {
                if (platformInVoked.isWx) {
                    // 跳转应用宝
                    evokeByWxAndroid(scheme);
                    downloadHandler && downloadHandler();
                }
                else if (platformInVoked.isOriginalChrome) {
                    // 原生谷歌使用tag方式打开
                    evokeByTagA(scheme);
                    checkOpenFall = checkOpen$1;
                }
                else {
                    // 其他情况下直跳
                    evokeByLocation(scheme);
                    checkOpenFall = checkOpen$1;
                }
            }
            else if (platformInVoked.isHarmony) {
                evokeByLocation(scheme);
                checkOpenFall = checkOpen$1;
            }
        }
        else {
            checkOpenFall = checkOpen$1;
        }
        // 其他情况静默失败
        if (openOnly)
            return true;
        downloadHandler && downloadHandler();
        var downloadAppInParams = downloadApp(scheme, android);
        checkOpenFall && checkOpenFall(downloadAppInParams, timeout);
        return true;
    };
    var openPrivacyAccess = function (params, callback) {
        if (typeof params === 'object' && params.message && typeof callback === 'function') {
            WBAPP.invoke('show_privacy_access', params, function (code) {
                callback(code);
            });
        }
        else {
            WBAPP.invoke('show_privacy_access', function (code) {
                if (callback && typeof callback === 'function') {
                    callback(code);
                }
            });
        }
    };

    var openAction$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        openOwnCertificateCameraPage: openOwnCertificateCameraPage,
        openAccountBinding: openAccountBinding,
        openCommunitySearch: openCommunitySearch,
        openInputDialog: openInputDialog,
        openSelectPickDialog: openSelectPickDialog$1,
        openFaceCertify: openFaceCertify,
        openWubaFBPhoto: openWubaFBPhoto,
        openAuth: openAuth$1,
        openIOSAppEvaluation: openIOSAppEvaluation,
        openResource: openResource,
        openFangBenCamera: openFangBenCamera$1,
        openPhotoSelect: openPhotoSelect,
        openMediaSelect: openMediaSelect$1,
        openVideoSelect: openVideoSelect$1,
        openAjkApp: openAjkApp,
        openPrivacyAccess: openPrivacyAccess
    });

    var HybridAnjuke = /** @class */ (function () {
        function HybridAnjuke() {
            this.ready = function (callback) {
                WBAPP.ready(function () {
                    if (callback)
                        callback();
                });
            };
            this.setAction = setAction$1;
            this.getAction = getAction$1;
            this.eventAction = eventAction$1;
            this.doAction = doAction$1;
            this.goAction = goAction$1;
            this.openAction = openAction$1;
            new Delegate(this, 'setAction').auto();
            new Delegate(this, 'getAction').auto();
            new Delegate(this, 'eventAction').auto();
            new Delegate(this, 'doAction').auto();
            new Delegate(this, 'goAction').auto();
            new Delegate(this, 'openAction').auto();
        }
        HybridAnjuke.prototype.init = function () {
            if (typeof WBAPP !== 'undefined') {
                console.log('init');
                WBAPP.invoke('init');
                WBAPP.invoke('ajk_log', {
                    jump_log: {
                        // 统一新增字段
                        action_code: '1954',
                        note: { url: window.location.href }
                    }
                });
            }
        };
        HybridAnjuke.prototype.getWebviewUrl = function (_a) {
            var url = _a.url, params = _a.params, _b = _a.isFinish, isFinish = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? '' : _c;
            return "openanjuke://jump/core/common?params=" + encodeURIComponent(JSON.stringify({
                url: url,
                title: title,
                list_name: '',
                ajk_type: (params && params.ajk_type) || '0',
                pagetype: 'common',
                categoryid: '',
                loadingtype: '0',
                backtoroot: 'false',
                domainTips: '',
                backprotocal: '',
                webType: '',
                save_step: false,
                pullRefresh: false,
                settings: {
                    hide_title_panel: (params && params.hideTitlePanel) || false,
                    contain_status_bar: (params && params.containStatusBar) || true,
                    status_bar_mode: (params && params.statusBarMode) || '',
                    status_bar_color: (params && params.statusBarColor) || ''
                }
            })) + "&isFinish=" + isFinish + "&needLogin=false&isBackToMain=false&isSlideinBottom=false&isNoAnimated=false";
        };
        HybridAnjuke.prototype.goWebview = function (params) {
            WBAPP.invoke('pagetrans', { protocol: this.getWebviewUrl(params) });
        };
        return HybridAnjuke;
    }());

    var VRSDK = '//pages.anjukestatic.com/usersite/touch/vr-connector/vrChatConnector-202207182000.js';
    var HybridVR = /** @class */ (function () {
        function HybridVR() {
            var _this = this;
            this.loadReady = false;
            this.actionList = [];
            load(VRSDK).then(function () {
                _this.loadReady = true;
                _this.initWindow();
                _this.excute();
            });
        }
        HybridVR.prototype.initWindow = function () {
            window.vrChatConnector();
            window.vrChatConnectorApi.requestRoomInfo();
            window.vrChatConnectorApi.interceptBackEvent();
        };
        HybridVR.prototype.init = function () {
            window.vrChatConnectorConfig = __assign(__assign({}, window.vrChatConnectorConfig), { biz: '', // 透传通道业务标识
                backEventCb: function (msg) {
                    window.vrChatConnectorApi.wvrExit();
                } });
            window.VRJSBizFunction = {
                closeVr: function () {
                    return false;
                }
            };
        };
        HybridVR.prototype.excute = function (func) {
            if (this.loadReady) {
                if (this.actionList.length > 0) {
                    this.actionList.forEach(function (itemFunc) {
                        if (typeof itemFunc === 'function') {
                            itemFunc();
                        }
                    });
                    this.actionList = [];
                }
                if (func)
                    func();
            }
            else {
                this.actionList.push(func);
            }
        };
        HybridVR.prototype.onBack = function (callback) {
            var _this = this;
            window.vrChatConnectorConfig.backEventCb = function (msg) {
                var result = callback(msg);
                if (!result) {
                    _this.goBack();
                }
            };
        };
        HybridVR.prototype.getAppInfo = function (callback) {
            var data = window.VRNativeBizFunction && window.VRNativeBizFunction.appInfo();
            return new Promise(function (resolve) {
                if (callback && typeof callback === 'function') {
                    callback(data);
                }
                resolve(data);
            });
        };
        HybridVR.prototype.getTitleBarHeight = function (callback) {
            var data = window.VRNativeBizFunction && window.VRNativeBizFunction.statusBarHeight();
            return new Promise(function (resolve) {
                if (callback && typeof callback === 'function') {
                    callback(data);
                }
                resolve(data);
            });
        };
        HybridVR.prototype.getLoginState = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.setVrBizCallback('getLoginState', function (msg) {
                    if (+msg === 0) {
                        resolve(msg);
                    }
                    else {
                        reject(msg);
                    }
                });
                _this.doCommonAction({ type: 'getLoginState' });
            });
        };
        HybridVR.prototype.getUserInfo = function () {
            var _this = this;
            return new Promise(function (resolve) {
                window.VRJSBizFunction.getUserInfo = function (msg) {
                    if (msg) {
                        resolve(JSON.parse(msg));
                    }
                    else {
                        resolve(null);
                    }
                };
                _this.doCommonAction({ type: 'getUserInfo' });
            });
        };
        HybridVR.prototype.setClose = function (callback) {
            if (callback && typeof callback === 'function') {
                window.VRJSBizFunction.closeVr = callback;
            }
        };
        HybridVR.prototype.setVrBizCallback = function (name, callback) {
            window.VRJSBizFunction[name] = callback;
        };
        HybridVR.prototype.setVrActionCallback = function (action, callback) {
            if (typeof callback === 'function' && window.vrChatConnectorConfig) {
                window.vrChatConnectorConfig[action] = callback;
            }
        };
        HybridVR.prototype.goBack = function () {
            this.doVrAction('wvrExit');
        };
        HybridVR.prototype.goNative = function (url) {
            this.doCommonAction({ type: 'route', data: url });
        };
        HybridVR.prototype.setShare = function (config) {
            this.shareConfig = config;
        };
        HybridVR.prototype.doShare = function (config) {
            this.doCommonAction({ type: 'share', data: config || this.shareConfig });
        };
        HybridVR.prototype.doLogin = function () {
            var _this = this;
            return new Promise(function (resolve) {
                window.VRJSBizFunction.loginCallback = function (msg) {
                    if (msg) {
                        resolve({ info: JSON.parse(msg), result: 0 });
                    }
                    else {
                        resolve({ info: null, result: 1 });
                    }
                };
                _this.doCommonAction({ type: 'login' });
            });
        };
        HybridVR.prototype.doVrAction = function () {
            var argv = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                argv[_i] = arguments[_i];
            }
            var action = argv[0];
            var arg = Array.from(argv).slice(1);
            if (window.vrChatConnectorApi[action] && typeof window.vrChatConnectorApi[action] === 'function') {
                return window.vrChatConnectorApi[action].apply(null, arg);
            }
            return undefined;
        };
        HybridVR.prototype.doPhoneCall = function (phone) {
            this.doCommonAction({ type: 'tel', data: "" + phone });
        };
        HybridVR.prototype.doCommonAction = function (_a) {
            var _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.data, data = _c === void 0 ? '' : _c;
            if (!type) {
                return;
            }
            // android
            if (window.WVRChatNativeFunction) {
                window.WVRChatNativeFunction.sendMessageToNative(type, data);
                return;
            }
            // ios
            if (window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.WVRChatSendMessageToNative) {
                window.webkit.messageHandlers.WVRChatSendMessageToNative.postMessage([type, data]);
            }
        };
        return HybridVR;
    }());
    ['onBack', 'getAppInfo', 'getTitleBarHeight', 'doVrAction', 'goBack', 'setVrActionCallback'].forEach(function (func) {
        var temp = HybridVR.prototype[func];
        HybridVR.prototype[func] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this.excute(temp.bind.apply(temp, __spreadArrays([this], args)));
        };
    });

    var NEW2OLD_MAPPING = {
        setRightText: 'setRightText',
        setTitle: 'setTitle',
        setShare: 'setShare',
        setCollection: 'setCollection',
        setTransparentDisabled: 'setTransparentDisabled',
        setConfigTitleData: 'configTitleData',
        setTitleAlpha: 'setTitleAlpha',
        setStatusBarStyle: 'setStatusBarStyle',
        setListDotHide: 'ajkHideSubscribeListDot',
        setGesture: 'toggleGesture',
        getLoginState: 'isLogin',
        getTitleBarHeight: 'getTitleBarHeight',
        doShare: 'callShare',
        doPay: 'pay',
        doPhoneCall: 'phone',
        doLogin: 'goAppLogin',
        onPhotoSelect: 'getPhotoInfo',
        onRightTextClick: 'onRightTextClick',
        onBack: 'controlBack',
        onActive: 'ajkDidBecomeActive',
        onUploadStatusUpdate: 'onUploadStatusUpdate',
        onPayResult: 'onPayResult',
        openPhotoSelect: 'selectPhoto',
        openOwnCertificateCameraPage: 'openOwnCertificateCameraPage',
        onAppSendOwnerPushCertificateBase64: 'appSendOwnerPushCertificateBase64',
        openAccountBinding: 'openAccountBinding',
        openCommunitySearch: 'openCommunitySearch',
        openInputDialog: 'openInputDialog',
        openSelectPickDialog: 'openSelectPickDialog',
        openFaceCertify: 'openFaceCertify',
        openWubaFBPhoto: 'openWubaFBPhoto',
        openAuth: 'openAuth',
        openIOSAppEvaluation: 'openIOSAppEvaluation',
        openResource: 'ajkOpenResource',
        goHome: 'goHome',
        goWebview: 'goWebview',
        goBack: 'goBack',
        openApp: 'openApp',
        openVideoSelect: 'openVideoSelect',
        onVideoPreview: 'onVideoPreview',
        openMediaSelect: 'ajk_media_picker',
        onMediaPreview: 'ajk_media_preview',
        onSaveImage: 'onSaveImage',
        getPrivacyAccess: 'get_privacy_access',
        openPrivacyAccess: 'show_privacy_access'
    };

    function setupWebViewJavascriptBridge(callback) {
        // 如果来自微信小程序
        if (window.browser && window.browser.versions && window.browser.versions.isMiniProgram) {
            return;
        }
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
    }

    var config$2 = {
        spiderList: ['bot', 'spider', 'yahoo'],
        semList: {
            'baidu.com': {
                refer: ['baidu.com']
            },
            'sogou.com': {
                refer: ['bill_cpc']
            },
            'so.com': {
                params: ['pi']
            },
            'haosou.com': {
                params: ['pi']
            },
            '360.cn': {
                params: ['pi']
            },
            'sm.cn': {
                params: ['pi']
            }
        },
        prefixes: ['webkit', 'moz', 'ms', 'o'],
        appInfo: {
            iosUrl: 'https://itunes.apple.com/cn/app/id415606289',
            iosHighUrl: 'https://mlink.anjuke.com/?',
            androidUrl: '//android.anjuke.com/download/anjuke/',
            pm: 'b318',
            version: '11.8.2',
            action: 'download',
            weixinUrl: '//a.app.qq.com/o/simple.jsp?pkgname=com.anjuke.android.app&g_f=991653&ipm=touch',
            iosWebView: 'openanjuke://app.anjuke.com/m/app/share_webview?page_url=',
            androidWebView: 'openanjuke://app.anjuke.com/app_tw_page?twurl='
        },
        reg: {
            schemeHeader: /^(openanjuke:\/\/)/,
            schemeHeader2: /^openanjuke/,
            m: /^([a-zA-Z0-9\-](\.)?)+(\.anjuke\.(com|test))$/
        }
    };

    /**
     * 获取页面隐藏属性的前缀
     * 如果页面支持 hidden 属性，返回 '' 就行
     * 如果不支持，各个浏览器对 hidden 属性，有自己的实现，不同浏览器不同前缀，遍历看支持哪个
     */
    var getPagePropertyPrefix$2 = function () {
        var prefixes = config$2.prefixes;
        var correctPrefix;
        if ('hidden' in document)
            return '';
        prefixes.forEach(function (prefix) {
            if (prefix + "Hidden" in document) {
                correctPrefix = prefix;
            }
        });
        return correctPrefix || false;
    };
    /**
     * 判断页面是否隐藏（进入后台）
     */
    var isPageHidden$2 = function () {
        var prefix = getPagePropertyPrefix$2();
        if (prefix === false)
            return '';
        var hiddenProperty = prefix ? prefix + "Hidden" : 'hidden';
        return document[hiddenProperty];
    };
    /**
     * 获取判断页面 显示|隐藏 状态改变的属性
     */
    var getVisibilityChangeProperty$2 = function () {
        var prefix = getPagePropertyPrefix$2();
        if (prefix === false)
            return false;
        return prefix + "visibilitychange";
    };
    var createTimer$2 = function (cb, timeout) {
        return setTimeout(function () {
            var hidden = isPageHidden$2();
            if (!hidden) {
                cb();
            }
        }, timeout);
    };
    /**
     * 检测是否唤端成功
     * @param {function} cb - 唤端失败回调函数
     * @param {number} timeout - 超时默认为3000
     */
    var checkOpen$2 = function (cb, timeout) {
        if (timeout === void 0) { timeout = 3000; }
        var visibilityChangeProperty = getVisibilityChangeProperty$2();
        var timer = createTimer$2(cb, timeout);
        // 针对上面函数返回为boolean或者string做类型保护
        if (visibilityChangeProperty && typeof visibilityChangeProperty === 'string') {
            document.addEventListener(visibilityChangeProperty, function () {
                clearTimeout(timer);
            });
        }
        window.addEventListener('pagehide', function () {
            clearTimeout(timer);
        });
        window.onblur = function () {
            clearTimeout(timer);
        };
        // 这里可能会出现在ios下应用不存在的弹层，也会触发onblur函数，所以手动再检测一次
        if (platform().ios) {
            window.onfocus = function () {
                window.onfocus = null;
                createTimer$2(cb, 1000);
            };
        }
    };
    /**
     * 通过 A 标签唤起
     * @param {string}} [url] - 需要打开的地址
     */
    var evokeByTagA$1 = function (url) {
        var tagA = document.createElement('a');
        tagA.setAttribute('href', url);
        tagA.style.display = 'none';
        document.body.appendChild(tagA);
        tagA.click();
    };
    /**
     * 通过 top.location.href 跳转
     * 使用 top 是因为在 qq 中打开的页面不属于顶级页面(iframe级别)
     * 自身 url 变更无法触动唤端操作
     * @param {string}} [url] - 需要打开的地址
     */
    var evokeByLocationTop$1 = function (url) {
        window.top.location.href = url;
    };
    var evokeByLocation$1 = function (url) {
        window.location.href = url;
    };
    var evokeByWxIOS$1 = function (url) {
        var encodeScheme = encodeURIComponent(url);
        if (encodeScheme) {
            evokeByLocation$1(config$2.appInfo.weixinUrl + "&ios_schema=" + encodeScheme);
        }
        else {
            evokeByLocation$1(config$2.appInfo.weixinUrl);
        }
    };
    var evokeByWxAndroid$1 = function (url) {
        var encodeScheme = encodeURIComponent(url);
        if (encodeScheme) {
            evokeByLocation$1(config$2.appInfo.weixinUrl + "&android_schema=" + encodeScheme);
        }
        else {
            evokeByLocation$1(config$2.appInfo.weixinUrl);
        }
    };
    var evokeByUniversalLink$1 = function (url) {
        var encodeScheme = encodeURIComponent(url);
        evokeByLocation$1(config$2.appInfo.iosHighUrl + "scheme=" + encodeScheme);
    };

    var checkIsLink$1 = function (href) { return config$2.reg.schemeHeader.test(href); };
    var checkIsUrl$1 = function (href) {
        if (/^http(s)?:\/\//.test(href)) {
            var host = href.replace(/^http(s)?:\/\//, '').split('/');
            return config$2.reg.m.test(host[0]);
        }
        return false;
    };
    var buildUrl$1 = function (href) {
        if (platform().ios)
            return "" + config$2.appInfo.iosWebView + encodeURIComponent(href);
        if (platform().android)
            return "" + config$2.appInfo.androidWebView + encodeURIComponent(href);
        return '';
    };
    var buildScheme$1 = function (href) {
        var link = '';
        // 这里可能出现二次encode情况，所以解码两次
        if (!config$2.reg.schemeHeader.test(href) && config$2.reg.schemeHeader2.test(href)) {
            href = decodeURIComponent(href || '');
        }
        if (checkIsUrl$1(href)) {
            link = buildUrl$1(href);
        }
        else if (checkIsLink$1(href)) {
            link = href;
        }
        return link;
    };
    var downloadApp$1 = function (scheme, android) { return function () {
        if (platform().isWx) {
            if (platform().ios) {
                evokeByWxIOS$1(scheme);
            }
            else {
                evokeByWxAndroid$1(scheme);
            }
        }
        else if (platform().ios) {
            evokeByLocation$1(config$2.appInfo.iosUrl);
        }
        else {
            var pm = android.pm || config$2.appInfo.pm;
            var androidLink = "" + config$2.appInfo.androidUrl + pm;
            if (platform().isHuaWeiBrowser) {
                evokeByTagA$1(androidLink);
            }
            else {
                evokeByLocation$1(androidLink);
            }
        }
        return true;
    }; };

    var defaultShareImg = 'https://pages.anjukestatic.com/usersite/touch/img/global/defaultImg/share_img.png';
    // 获取个平台的分享信息
    function getShareContent(params) {
        //增加对数组的支持
        if (params instanceof Array) {
            return JSON.stringify(params);
        }
        params = typeof params === 'object' ? params : JSON.parse(params);
        var platform = typeof (params.platform) == 'undefined' ? ['wxhy', 'pyq', 'sinawb', 'wl'] : params.platform;
        var length = platform.length;
        var data = [];
        for (var i = 0; i < length; i++) {
            var config_1 = JSON.parse(JSON.stringify(params));
            config_1.pm = platform[i];
            // 设置默认图片，否则将无法吊起分享
            config_1.image = config_1.image || defaultShareImg;
            if (platform[i] === 'wxmp') {
                // shareConfig.url = '/page/outpage/pages/home/web/index?web_url=' + encodeURIComponent(this.article.share.url || window.location.href)
                config_1.param = params.param;
            }
            data.push(config_1);
        }
        return JSON.stringify(data);
    }
    function setRightBtn(data) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('anjuke_native_header_right_btn_text', data, function () { });
        });
    }
    function setRightHandler(callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler('anjuke_native_header_right_btn_text_click', callback);
        });
    }
    function backUserApp(closeWebview) {
        if (closeWebview === void 0) { closeWebview = false; }
        var length = history.length;
        if (length > 1 && !closeWebview) {
            // 如果webview有其它路径
            history.back();
        }
        else {
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('closeAnjukeWebViewPage', null, null);
            });
        }
    }
    function backupHandler(callback) {
        window.callJSLoadPageFinish = function () {
            callback();
        };
    }
    // 获取状态栏和导航栏高度
    function getTitleBarHeight$1(callback) {
        var dpr = 1;
        if (browser.versions.android) {
            dpr = window.devicePixelRatio;
        }
        backupHandler(function () {
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('getTitleBarHeight', '', function (data) {
                    callback(data / dpr);
                });
            });
        });
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('getTitleBarHeight', '', function (data) {
                callback(data / dpr);
            });
        });
    }
    // 取消滚动渐变 1:禁止 0:开启
    function setTransparentDisabled$1(value, callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('setTransparentDisabled', value, function () {
                callback();
            });
        });
    }
    /*
    数据格式
    {
        "bgColor" : "#aaaaaa”,// 不透明时的背景色
        "scrollHeight" : “200”,// 滚动渐变的高度区间
        "iconStart" :"0”,//初始透明时 icon ，0为默认灰色 icon，1为白色高亮 icon
        "iconEnd" : "1”,// 结束状态不透明时 icon
        "textStartColor" : "#aaaaaa”, // 初始透明时 title 文本颜色
        "textEndColor" : "#aaaaaa"// 结束状态不透明 title 文本颜色
    }
    */
    function configTitleData(config) {
        var dpr = 1;
        if (browser.versions.android) {
            dpr = window.devicePixelRatio;
        }
        config.scrollHeight = parseInt(Number(config.scrollHeight) * dpr) + '';
        var configStr = JSON.stringify(config);
        backupHandler(function () {
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('configTitleData', configStr, null);
            });
        });
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('configTitleData', configStr, null);
        });
    }
    // 设置头部的透明度
    function setTitleAlpha$1(alpha) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('setTitleAlpha', alpha, function () { });
        });
    }
    // 设置类似电量这些图标的颜色 0 黑色 1白色
    function setStatusBarStyle$2(value) {
        backupHandler(function () {
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('setStatusBarStyle', value, function () { });
            });
        });
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('setStatusBarStyle', value, function () { });
        });
    }
    function goWebview$1(_a) {
        var _b = _a === void 0 ? {} : _a, url = _b.url, params = _b.params;
        if (url.indexOf('%') < 0) {
            url = encodeURIComponent(url);
        }
        // 判断是否来自全景
        if (url.indexOf('vrview') >= 0) {
            location.href = 'openanjuke://app.anjuke.com/m/app/webview_720?page_url=' + url;
            return;
        }
        location.href = 'openanjuke://app.anjuke.com/m/app/share_webview?page_url=' + url;
    }
    function onUploadStatusUpdate$1(callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler("onUploadStatusUpdate", function (data) {
                callback(data);
            });
        });
    }
    function openOwnCertificateCameraPage$1(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler("openOwnCertificateCameraPage", params, function (data, responseCallback) {
            });
        });
    }
    function appSendOwnerPushCertificateBase64(callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler("appSendOwnerPushCertificateBase64", callback);
        });
    }
    function phone(number) {
        location.href = 'tel:' + number;
    }
    function callShare(params) {
        if (params === void 0) { params = ''; }
        location.href = 'call-app-method://shareButtonClick?' + params;
    }
    /**
     * 搜索小区
     */
    function openCommunitySearchCommon(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(params.callback, params[params.callback]);
            bridge.callHandler('openCommunitySearch', params);
        });
    }
    /**
     * 输入组件
     */
    function openInputDialogCommon(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(params.callback, params[params.callback]);
            bridge.callHandler('openInputDialog', params);
        });
    }
    /**
     * 滑动选择
     */
    function openSelectPickDialogCommon(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(params.callback, params[params.callback]);
            bridge.callHandler('pub_picker_input', params);
        });
    }
    /**
     * 实名认证
     */
    function openFaceCertifyCommon(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(params.callback, params[params.callback]);
            bridge.callHandler('ajkOpenFaceCertify', params);
        });
    }
    /**
     * 58 房本拍照
     */
    function openWubaFBPhotoCommon(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler('_wuba_fangben_upload_callback', params.realCallback);
            bridge.callHandler('_wuba_fangben_upload_component', params);
        });
    }
    function goHome$1() {
        location.href = 'openanjuke://app.anjuke.com/m/app/main_tab_page';
    }
    function openAjkApp$1(params) {
        var checkOpenFall = null;
        var platformInVoked = platform();
        var scheme = buildScheme$1(params.href);
        if (!scheme && !params.downloadOnly) {
            params.urlErrorHandler && params.urlErrorHandler();
            return false;
        }
        if (!params.downloadOnly) {
            params.awakeHandler && params.awakeHandler();
            if (platformInVoked.ios) {
                if (platformInVoked.isWx && compareVersion(getWeChatVersion(), '7.0.5') >= 0) {
                    evokeByUniversalLink$1(scheme);
                }
                else if (platformInVoked.isWx) {
                    evokeByWxIOS$1(scheme);
                }
                else if (platformInVoked.isQQ || platformInVoked.isQQBrowser) {
                    evokeByLocationTop$1(config$2.appInfo.iosUrl);
                    params.downloadHandler && params.downloadHandler();
                }
                else {
                    evokeByLocation$1(scheme);
                    checkOpenFall = checkOpen$2;
                }
            }
            else if (platformInVoked.android) {
                if (platformInVoked.isWx) {
                    // 跳转应用宝
                    evokeByWxAndroid$1(scheme);
                    downloadHandler && downloadHandler();
                }
                else if (platformInVoked.isOriginalChrome) {
                    // 原生谷歌使用tag方式打开
                    evokeByTagA$1(scheme);
                    checkOpenFall = checkOpen$2;
                }
                else {
                    // 其他情况下直跳
                    evokeByLocation$1(scheme);
                    checkOpenFall = checkOpen$2;
                }
            }
        }
        else {
            checkOpenFall = checkOpen$2;
        }
        // 其他情况静默失败
        if (params.openOnly)
            return true;
        params.downloadHandler && params.downloadHandler();
        var downloadAppInParams = downloadApp$1(scheme, params.android);
        checkOpenFall && checkOpenFall(downloadAppInParams, params.timeout);
        return true;
    }

    function setTitle$2(title) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('ajkSetTitle', title, function responseCallback() { });
        });
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('setCurrentWebViewTitle', {
                title: title
            });
        });
    }
    /**
     *
     * @param {} params
     * params 包含如下四个参数
     * image 图片
     * description 描述
     * url 打开连接
     * title 标题
     */
    function setShare$1(params) {
        var content = getShareContent(params);
        // 12.9 以下的兼容逻辑
        window.getShareContents = function () {
            return content;
        };
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('ajkSetShareContents', content, function responseCallback() { });
        });
    }
    function appLogin(callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler('ajkMemberInfoCallBack', function (data) {
                callback(data, 0);
            });
        });
    }
    function goAppLogin(params, callback) {
        if (callback === void 0) { callback = function () { }; }
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler('ajkLoginCanelled', function (data) {
                callback(null, 1);
            });
        });
        location.href = 'call-app-method://thirdPartyLogInAndRegister';
    }
    function selectPhoto(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('ajkShowPhotoActionSheet', JSON.stringify(params));
        });
    }
    function getPhotoInfo(callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler('appSendBase64', function (array) {
                callback(array);
            });
        });
    }
    function controlBack(callback) {
        window.checkAjkAppUseGoBack = callback;
    }
    function setRightText$1(name) {
        return setRightBtn(name);
    }
    function onRightTextClick$1(callback) {
        return setRightHandler(callback);
    }
    function goBack$2(closeWebview) {
        return backUserApp(closeWebview);
    }
    function ajkDidBecomeActive(callback) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler("ajkViewDidAppear", function () {
                callback();
            });
        });
    }
    function ajkHideSubscribeListDot() {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler("ajkHideSubscribeListDot", function (data, responseCallback) { });
        });
    }
    function invoke(_a) {
        var actionName = _a.actionName, href = _a.href;
        location.href = href;
    }
    /* 调起账号绑定 */
    function openAccountBinding$1() {
        console.log('对不起，该版本不支持账号绑定');
        return;
    }
    /**
     * 小区选择组件
     */
    function openCommunitySearch$1(params, callback) {
        return openCommunitySearchCommon(params);
    }
    /**
     * 输入
     */
    function openInputDialog$1(params, callback) {
        return openInputDialogCommon(params);
    }
    /**
     * 滑动选择
     */
    function openSelectPickDialog$2(params, callback) {
        return openSelectPickDialogCommon(params);
    }
    /**
     * 禁止ios手势
     */
    function forbiddenGesture(params) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler("ajkSetPageConfig", params);
        });
    }
    /**
     * 实名认证
     */
    function openFaceCertify$1(params, callback) {
        return openFaceCertifyCommon(params);
    }
    function openWubaFBPhoto$1(params, callback) {
        return openWubaFBPhotoCommon(params);
    }

    var IosAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        invoke: invoke,
        setTitle: setTitle$2,
        setShare: setShare$1,
        appLogin: appLogin,
        goAppLogin: goAppLogin,
        selectPhoto: selectPhoto,
        getPhotoInfo: getPhotoInfo,
        controlBack: controlBack,
        setRightText: setRightText$1,
        onRightTextClick: onRightTextClick$1,
        goBack: goBack$2,
        ajkDidBecomeActive: ajkDidBecomeActive,
        ajkHideSubscribeListDot: ajkHideSubscribeListDot,
        goWebview: goWebview$1,
        onUploadStatusUpdate: onUploadStatusUpdate$1,
        openOwnCertificateCameraPage: openOwnCertificateCameraPage$1,
        appSendOwnerPushCertificateBase64: appSendOwnerPushCertificateBase64,
        phone: phone,
        callShare: callShare,
        openAccountBinding: openAccountBinding$1,
        openCommunitySearch: openCommunitySearch$1,
        openInputDialog: openInputDialog$1,
        openSelectPickDialog: openSelectPickDialog$2,
        forbiddenGesture: forbiddenGesture,
        openFaceCertify: openFaceCertify$1,
        openWubaFBPhoto: openWubaFBPhoto$1,
        getTitleBarHeight: getTitleBarHeight$1,
        configTitleData: configTitleData,
        setTitleAlpha: setTitleAlpha$1,
        setTransparentDisabled: setTransparentDisabled$1,
        setStatusBarStyle: setStatusBarStyle$2,
        goHome: goHome$1,
        openAjkApp: openAjkApp$1
    });

    function setTitle$3(title) {
        console.log('settitle', title);
        backupHandler$1(function () {
            window.MyHandler && window.MyHandler.setAjkTitle(title);
        });
        return window.MyHandler && window.MyHandler.setAjkTitle(title);
    }
    function backupHandler$1(callback) {
        window.callJSLoadPageFinish = function () {
            callback();
        };
    }
    function invoke$1(_a) {
        var actionName = _a.actionName, href = _a.href;
        location.href = href;
    }
    /**
     *
     * @param {} params
     * params 包含如下四个参数
     * image 图片
     * description 描述
     * url 打开连接
     * title 标题
     */
    function setShare$2(params) {
        var content = getShareContent(params);
        return window.MyHandler && window.MyHandler.ajkSetShareContents(content);
    }
    function appLogin$1(callback) {
        window.logInAndRegisterFinish = function (type) {
            var userinfo = _getAndroidUserInfo();
            callback(userinfo, 0);
        };
    }
    function _getAndroidUserInfo() {
        var memberID = window.MyHandler.getMemberId();
        var memberToken = window.MyHandler.getUserMemberAuthToken();
        var chatID = window.MyHandler.getUserId();
        var chatToken = window.MyHandler.getUserChatAuthToken();
        var info = (window.MyHandler.ajkGetUserInfo && window.MyHandler.ajkGetUserInfo()) || {};
        var auth = typeof info === 'string' ? JSON.parse(info).ajkAuthTicket : info.ajkAuthTicket;
        return {
            memberID: memberID,
            memberToken: memberToken,
            chatID: chatID,
            chatToken: chatToken,
            ajkAuthTicket: auth
        };
    }
    function goAppLogin$1(params, callback) {
        if (callback === void 0) { callback = function () { }; }
        window.loginCallBack = function (status) {
            if (!status) {
                callback(null, 1);
            }
        };
        location.href = 'openanjuke://app.anjuke.com/m/common/login_entry?wxentry_activity_launch_by_self=true';
    }
    // 选择相册
    function selectPhoto$1(params) {
        return window.Android && window.Android.showPickDialog(JSON.stringify(params));
    }
    // 选择图片完成后返回base64数组
    function getPhotoInfo$1(callback) {
        window.appSendBase64 = callback;
    }
    function controlBack$1(callback) {
        window.checkAjkAppUseGoBack = callback;
    }
    function setRightText$2(name) {
        backupHandler$1(function () {
            setRightBtn(name);
        });
        return setRightBtn(name);
    }
    function onRightTextClick$2(callback) {
        return setRightHandler(callback);
    }
    function goBack$3(closeWebview) {
        return backUserApp(closeWebview);
    }
    function ajkDidBecomeActive$1(callback) {
        window.ajkDidBecomeActive = callback;
    }
    function ajkHideSubscribeListDot$1() {
        window.MyHandler && window.MyHandler.ajkHideSubscribeListDot();
    }
    /* 调起账号绑定 */
    function openAccountBinding$2() {
        console.log('对不起，该版本不支持账号绑定');
        return;
    }
    /**
     * 小区选择组件
     */
    function openCommunitySearch$2(params, callback) {
        return openCommunitySearchCommon(params);
    }
    /**
     * 输入
     */
    function openInputDialog$2(params, callback) {
        return openInputDialogCommon(params);
    }
    /**
     * 滑动选择
     */
    function openSelectPickDialog$3(params, callback) {
        return openSelectPickDialogCommon(params);
    }
    /**
     * 禁止ios手势
     */
    function forbiddenGesture$1(params) {
        console.log('android 不支持禁止手势');
        return;
    }
    /**
     * 实名认证
     */
    function openFaceCertify$2(params, callback) {
        return openFaceCertifyCommon(params);
    }
    function openWubaFBPhoto$2(params, callback) {
        return openWubaFBPhotoCommon(params);
    }

    var AndroidAction = /*#__PURE__*/Object.freeze({
        __proto__: null,
        invoke: invoke$1,
        setTitle: setTitle$3,
        setShare: setShare$2,
        appLogin: appLogin$1,
        goAppLogin: goAppLogin$1,
        selectPhoto: selectPhoto$1,
        getPhotoInfo: getPhotoInfo$1,
        controlBack: controlBack$1,
        setRightText: setRightText$2,
        onRightTextClick: onRightTextClick$2,
        goBack: goBack$3,
        ajkDidBecomeActive: ajkDidBecomeActive$1,
        ajkHideSubscribeListDot: ajkHideSubscribeListDot$1,
        goWebview: goWebview$1,
        onUploadStatusUpdate: onUploadStatusUpdate$1,
        openOwnCertificateCameraPage: openOwnCertificateCameraPage$1,
        appSendOwnerPushCertificateBase64: appSendOwnerPushCertificateBase64,
        phone: phone,
        callShare: callShare,
        openAccountBinding: openAccountBinding$2,
        openCommunitySearch: openCommunitySearch$2,
        openInputDialog: openInputDialog$2,
        openSelectPickDialog: openSelectPickDialog$3,
        forbiddenGesture: forbiddenGesture$1,
        openFaceCertify: openFaceCertify$2,
        openWubaFBPhoto: openWubaFBPhoto$2,
        setStatusBarStyle: setStatusBarStyle$2,
        configTitleData: configTitleData,
        setTitleAlpha: setTitleAlpha$1,
        getTitleBarHeight: getTitleBarHeight$1,
        setTransparentDisabled: setTransparentDisabled$1,
        goHome: goHome$1,
        openAjkApp: openAjkApp$1
    });

    /**
     * 已支持的 Action
     * setTitle 设置标题
     * setShare 设置分享
     */
    var Driver = /** @class */ (function () {
        function Driver() {
            this.actions = platform().ios ? IosAction : AndroidAction;
        }
        Driver.prototype.doAction = function (action, params, callback) {
            if (callback === void 0) { callback = function () { }; }
            console.log('doAction', action, params);
            console.log(this.actions);
            this.actions[action] && this.actions[action](params, callback);
        };
        Driver.prototype.getData = function (action, callback) {
            this.actions[action] && this.actions[action](callback);
        };
        return Driver;
    }());

    /** @format */
    var SDK = 'https://a.58cdn.com.cn/app58/rms/app/js/app_30805.js?cachevers=1090';
    var TONGZHENSDK = 'https://a.58cdn.com.cn/app58/rms/app/js/wbutownSdk.min_31835.js';
    var WXSdk = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
    var BDSdk = 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.31.js';
    var TTSdk = 'https://lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.1.0.js';
    var ZFBSdk = 'https://appx/web-view.min.js';
    var WubaSDKs = [WXSdk, '//weixin.58.com/weixinjsconfig/config', '//fangfe.58.com/spage/js/lib/callWbApp_2019_min.js'];
    var Zepto = '//pages.anjukestatic.com/usersite/touch/js/zeptoajax/zepto.min.js';
    var Hybrid = /** @class */ (function () {
        function Hybrid(config) {
            var _this = this;
            if (config === void 0) { config = { isDev: false, unloadWubaSDKs: false }; }
            this.queues = [];
            this.isTongzhen = function (url) {
                if (url === void 0) { url = ''; }
                return !!~url.indexOf('wbutown');
            };
            this.isOpenWebView = function (url, isApp) {
                if (url === void 0) { url = ''; }
                if (isApp === void 0) { isApp = false; }
                if (!isApp)
                    return false;
                return url.indexOf('http') === 0;
            };
            this.fixGlobalName = function () {
                if (typeof WBUTOWN !== 'undefined') {
                    window.WBAPP = WBUTOWN;
                }
            };
            this.openApp = function (params) {
                if (_this.isWuba(params.href)) {
                    _this.actions.openWubaApp(params);
                }
                else {
                    _this.actions.openAjkApp(params, _this.log);
                }
            };
            this.getWebViewUrl = function (params) {
                if (_this.isWeb) {
                    if (_this.isTongzhen(params.url)) {
                        _this.actions = new HybridTongzhen();
                    }
                    else if (_this.isWuba(params.url)) {
                        _this.actions = new Hybrid58();
                    }
                    else {
                        _this.actions = new HybridAnjuke();
                    }
                }
                return _this.actions.getWebviewUrl(params);
            };
            this.goWebview = function (_a) {
                var url = _a.url, _b = _a.isFinish, isFinish = _b === void 0 ? false : _b, title = _a.title, params = _a.params;
                // 防止多次encode
                if (url.indexOf('%') >= 0) {
                    url = decodeURIComponent(url);
                }
                if (_this.isWeb) {
                    _this.openApp(__assign({ href: url, isFromWebview: true }, params));
                }
                else {
                    _this.actions.goWebview({
                        url: url,
                        isFinish: isFinish,
                        title: title,
                        params: params
                    });
                }
            };
            this.goNative = function (params) {
                var url = '';
                // 兼容单href场景
                if (typeof params === 'string') {
                    url = params;
                }
                else {
                    url = params.href || params.url;
                }
                if (_this.type === 'vr') {
                    _this.actions.goNative(params);
                    return;
                }
                if (_this.isWeb) {
                    _this.openApp(__assign({ href: url, isFromWebview: true }, params));
                }
                else if (typeof WBAPP !== 'undefined') {
                    WBAPP.invoke('pagetrans', {
                        protocol: url
                    });
                }
            };
            /**
             * 封装统一的jump服务，适合在各个场景下的跳转
             */
            this.jump = function (url, params) {
                if (params === void 0) { params = {
                    isFinish: false,
                    isOpenNewWebview: false,
                    isRedirect: false,
                    isWuba: false
                }; }
                if (!url)
                    return;
                var isApp = [TYPE$1.WUBA, TYPE$1.ANJUKE].includes(_this.type);
                var newUrl = '';
                var isUrlH5 = true;
                if (url &&
                    url.includes('http') &&
                    (url.includes('anjuke.com') || url.includes('.58.com')) &&
                    !url.includes('openanjuke') &&
                    !url.includes('wbmain')) {
                    isUrlH5 = true;
                    newUrl = url.replace('http://', 'https://');
                }
                else if (url && !url.includes('openanjuke') && !url.includes('wbmain')) {
                    isUrlH5 = false;
                    newUrl = url;
                    if (url.substring(0, 1) !== '/') {
                        newUrl = "/" + url;
                    }
                }
                // 防止多次encode
                if (newUrl.indexOf('%') >= 0) {
                    newUrl = decodeURIComponent(newUrl);
                }
                if (_this.newType === TYPE$1.WEAPP) {
                    // 微信小程序
                    if (isUrlH5) {
                        if (params.isWuba) {
                            // 是否是58房产小程序
                            newUrl = "/page/main/subpages/webview/index?url=" + encodeURIComponent(newUrl);
                        }
                        else {
                            newUrl = "/page/outpage/pages/home/web/index?web_url=" + encodeURIComponent(newUrl);
                        }
                    }
                    if (params.isRedirect) {
                        window.wx.miniProgram.redirectTo({ url: newUrl });
                    }
                    else {
                        window.wx.miniProgram.navigateTo({ url: newUrl });
                    }
                    return;
                }
                if (_this.newType === TYPE$1.BDAPP) {
                    // 百度小程序
                    if (isUrlH5) {
                        newUrl = "/page/outpage/pages/home/web/index?web_url=" + encodeURIComponent(newUrl);
                    }
                    if (params.isRedirect) {
                        window.swan.webView.redirectTo({ url: newUrl });
                    }
                    else {
                        window.swan.webView.navigateTo({ url: newUrl });
                    }
                    return;
                }
                if (_this.newType === TYPE$1.ZFBAPP) {
                    if (isUrlH5) {
                        newUrl = "/pages/webview/index?web_url=" + encodeURIComponent(newUrl);
                    }
                    // 支付宝小程序
                    if (params.isRedirect) {
                        window.my.redirectTo({ url: newUrl });
                    }
                    else {
                        window.my.navigateTo({ url: newUrl });
                    }
                    return;
                }
                if (_this.newType === TYPE$1.TTAPP) {
                    if (isUrlH5) {
                        newUrl = "/pages/webview/index?url=" + encodeURIComponent(newUrl);
                    }
                    // 抖音小程序
                    if (params.isRedirect) {
                        window.tt.miniProgram.redirectTo({ url: newUrl });
                    }
                    else {
                        window.tt.miniProgram.navigateTo({ url: newUrl });
                    }
                    return;
                }
                if (_this.newType === TYPE$1.KSAPP) {
                    if (isUrlH5) {
                        newUrl = "/page/main/subpages/webview/index?url=" + encodeURIComponent(newUrl);
                    }
                    // 快手小程序
                    if (params.isRedirect) {
                        window.ks.navigateTo({ url: newUrl });
                    }
                    else {
                        window.ks.navigateTo({ url: newUrl });
                    }
                    return;
                }
                if (params.isOpenNewWebview && _this.isOpenWebView(url, isApp)) {
                    _this.goWebview({ url: url, isFinish: params.isFinish, title: '', params: '' });
                    return;
                }
                if (_this.type === TYPE$1.WEB || _this.type === TYPE$1.WEIXIN) {
                    if (params.isRedirect) {
                        window.location.replace(url);
                    }
                    else {
                        window.location.href = url;
                    }
                }
                else {
                    _this.goNative(url);
                }
            };
            this.setWXShare = function (params) {
                // 临时先做队列化
                var dependQueue = [];
                var defaultShareImg = 'https://pages.anjukestatic.com/usersite/touch/img/global/defaultImg/share_img.png';
                if (!window.$)
                    dependQueue.push(Zepto);
                if (!window.wx)
                    dependQueue.push(WXSdk);
                return Promise.all(dependQueue).then(function () {
                    window.$.ajax({
                        // url: '//api.anjuke.com/weixin/common/share_js_ticket',
                        // url: '//m.anjuke.com/xinfang/api/weixin/ticket',
                        url: '/xinfang/api/weixin/ticket',
                        data: {
                            url: window.location.origin + window.location.pathname + window.location.search
                        },
                        dataType: 'json',
                        success: function (res) {
                            // //wxsdk 用于微信，qq分享
                            // wx.config({
                            //     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            //     appId: res.appId, // 必填，公众号的唯一标识
                            //     timestamp: res.timestamp, // 必填，生成签名的时间戳
                            //     nonceStr: res.nonceStr, // 必填，生成签名的随机串
                            //     signature: res.signature, // 必填，签名，见附录1
                            //     jsApiList: [
                            //         'onMenuShareTimeline',
                            //         'onMenuShareAppMessage',
                            //         'onMenuShareQQ'
                            //     ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                            // });
                            // wxsdk 用于微信，qq分享
                            var result = res.result;
                            window.wx.config({
                                debug: false,
                                appId: result.appid,
                                timestamp: result.timestamp,
                                nonceStr: result.noncestr,
                                signature: result.signature,
                                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                            });
                            var wxTitle = params.title;
                            var wxDesc = params.description;
                            var wxLink = params.url;
                            var wxImgUrl = params.image || defaultShareImg;
                            window.wx.ready(function () {
                                window.wx.onMenuShareAppMessage({
                                    title: wxTitle,
                                    desc: wxDesc,
                                    link: wxLink,
                                    imgUrl: wxImgUrl,
                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });
                                window.wx.onMenuShareTimeline({
                                    title: wxTitle,
                                    link: wxLink,
                                    imgUrl: wxImgUrl,
                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });
                                window.wx.onMenuShareQQ({
                                    title: wxTitle,
                                    desc: wxDesc,
                                    link: wxLink,
                                    imgUrl: wxImgUrl,
                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });
                            });
                        }
                    });
                });
            };
            this.variableFill = function () {
                var funcArray = [
                    'ajkDidBecomeActive',
                    'ajkViewDidDisappear',
                    'ajkNativeHeaderBackButtonClick',
                    'ajkDidEnterBackground',
                    'checkAjkAppUseGoBack',
                    'getCollectContents',
                    // 百度地图
                    'setInfo',
                    // 高德地图
                    '__mapview__rightbutton',
                    // 移动经纪人
                    'reloadwebview',
                    'WebViewJavascriptBridge'
                ];
                if (typeof window !== 'undefined') {
                    for (var i = 0; i < funcArray.length; i++) {
                        if (!window[funcArray[i]]) {
                            window[funcArray[i]] = function (f) { return f; };
                        }
                    }
                }
            };
            var type = config.type, version = config.version, sdk = config.sdk, isDev = config.isDev, originType = config.originType, _a = config.unloadWubaSDKs, unloadWubaSDKs = _a === void 0 ? false : _a;
            var Action = null;
            this.type = type;
            this.originType = originType;
            this.version = version;
            this.log = log(isDev);
            this.variableFill();
            if (!type || !originType || !version) {
                var appInfo = getAppByUA();
                if (this.isVr()) {
                    this.type = TYPE$1.VR;
                }
                else {
                    this.type = type || appInfo.type;
                }
                this.newType = appInfo.type || this.type;
                this.originType = originType || appInfo.originType;
                this.version = version || appInfo.version;
            }
            this.sdk = sdk || (this.originType === TYPE$1.TONGZHEN ? TONGZHENSDK : SDK);
            if (this.type === TYPE$1.ANJUKE && !this.isOldAjk) {
                Action = HybridAnjuke;
            }
            else if (this.type === TYPE$1.ANJUKE) {
                Action = Driver;
            }
            else if (this.type === TYPE$1.WUBA) {
                if (this.originType === TYPE$1.TONGZHEN) {
                    Action = HybridTongzhen;
                }
                else if (this.originType === TYPE$1.WUBA) {
                    Action = Hybrid58;
                }
            }
            else if (this.type === TYPE$1.VR) {
                Action = HybridVR;
            }
            if (!Action) {
                Action = this.HybridH5;
            }
            this.actions = new Action();
            if (this.isOldAjk) {
                this.actions = this.actions.actions;
            }
            this.access('init')
                .access('setRightText')
                .access('setTitle')
                .access('setShare')
                .access('setWXShare')
                .access('setCollection')
                .access('setTransparentDisabled')
                .access('setConfigTitleData')
                .access('setTitleAlpha')
                .access('setStatusBarStyle')
                .access('setListDotHide')
                .access('setGesture')
                .access('setProgress')
                .access('setNotification')
                .access('setVrActionCallback')
                .access('setVrBizCallback')
                .access('getUserInfo')
                .access('getLoginState')
                .access('getTitleBarHeight')
                .access('getStatusBarHeight')
                .access('getWebviewUrl')
                .access('getAppInfo')
                .access('onRightTextClick')
                .access('onBack')
                .access('onActive')
                .access('onUploadStatusUpdate')
                .access('onPayResult')
                .access('onCollectionClick')
                .access('onPhotoSelect')
                .access('onVideoPreview')
                .access('onMediaPreview')
                .access('doShare')
                .access('doLogin')
                .access('doPhoneCall')
                .access('doPay')
                .access('doAction')
                .access('doAuthorize')
                .access('doVrAction')
                .access('doCommonAction')
                .access('goBack')
                .access('goHome')
                .access('openOwnCertificateCameraPage')
                .access('openAccountBinding')
                .access('openCommunitySearch')
                .access('openInputDialog')
                .access('openSelectPickDialog')
                .access('openFaceCertify')
                .access('openWubaFBPhoto')
                .access('openAuth')
                .access('openIOSAppEvaluation')
                .access('openResource')
                .access('openFangBenCamera')
                .access('openPhotoSelect')
                .access('openPhotoSelectCommon')
                .access('openVideoSelect')
                .access('openAjkApp')
                .access('openWubaApp')
                .access('openMediaSelect')
                .access('onSaveImage')
                .access('getPrivacyAccess')
                .access('openPrivacyAccess')
                .access('doXXWX')
                .access('ready')
                .access('getLocationInfo')
                .access('setHideHeaderRightButton')
                .access('doLoginDialog')
                .access('getCacheLocationInfo')
                .access('getComplianceLocationInfo')
                .access('getDeviceData');
            this.init();
            // 58微信直唤所需的sdk,安居客、百度、支付宝、抖音、快手小程序sdk加载
            if (type !== 'vr' || !unloadWubaSDKs) {
                if (this.newType === TYPE$1.BDAPP) {
                    console.log('loadByQueue(BDSdk);');
                    loadByQueue(BDSdk);
                }
                else if (this.newType === TYPE$1.TTAPP) {
                    console.log('loadByQueue(TTSdk);');
                    loadByQueue(TTSdk);
                }
                else if (this.newType === TYPE$1.ZFBAPP) {
                    console.log('loadByQueue(ZFBSdk);');
                    loadByQueue(ZFBSdk);
                }
                else {
                    console.log('loadByQueue(WubaSDKs);');
                    loadByQueue(WubaSDKs);
                }
            }
        }
        Object.defineProperty(Hybrid.prototype, "mapping", {
            get: function () {
                return NEW2OLD_MAPPING;
            },
            enumerable: false,
            configurable: true
        });
        Hybrid.prototype.isVr = function () {
            return !!(window.WVRChatNativeFunction ||
                (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.WVRChatSendMessageToNative));
        };
        Object.defineProperty(Hybrid.prototype, "isWeb", {
            get: function () {
                return this.type === TYPE$1.WEB || !this.type;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Hybrid.prototype, "isOldAjk", {
            get: function () {
                // 排除鸿蒙，安居客马甲包，版本号比较低
                return (this.type === TYPE$1.ANJUKE &&
                    compareVersion(this.version, '12.17') < 0 &&
                    !navigator.userAgent.includes('AJKHarmony') &&
                    !navigator.userAgent.includes('AJKHOUSE'));
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Hybrid.prototype, "HybridH5", {
            get: function () {
                if (this.isWuba()) {
                    return Hybrid58;
                }
                return HybridAnjuke;
            },
            enumerable: false,
            configurable: true
        });
        Hybrid.prototype.isWuba = function (url) {
            if (url === void 0) { url = ''; }
            var host = url;
            if (!url && typeof location === 'object') {
                host = location.host;
            }
            return !!~host.indexOf('.58.') || !!~host.indexOf('wbmain') || !!~host.indexOf('wbutown');
        };
        Hybrid.prototype.injectH5Support = function (action, params) {
            this.log("in h5 env: " + action + " invoke with params: " + JSON.stringify(params), TYPE.WARN);
            // 兼容H5中回调
            return Promise.resolve({});
        };
        Hybrid.prototype.injectUnknownFuncSupport = function (action) {
            var _this = this;
            return function () {
                _this.log("in " + _this.type + " env: " + action + " is not support, please check carefully~");
                return Promise.resolve({});
            };
        };
        Hybrid.prototype.access = function (action) {
            var _this = this;
            // 老版本兼容
            if (this.isOldAjk) {
                this[action] = function (params) {
                    _this.log("in " + _this.type + ":" + _this.version + " auto mapping " + action + " to " + NEW2OLD_MAPPING[action]);
                    action = NEW2OLD_MAPPING[action];
                    var taskFunc = _this.actions[action] ? _this.actions[action] : _this.injectUnknownFuncSupport(action);
                    return new Promise(function (resolve) {
                        taskFunc.call(_this.actions, params, function (res) {
                            resolve(res);
                        });
                    });
                };
                return this;
            }
            this[action] = function (params, callback) {
                if (_this.isWeb) {
                    return _this.injectH5Support(action, params);
                }
                var taskFunc = _this.actions[action] ? _this.actions[action] : _this.injectUnknownFuncSupport(action);
                if (typeof WBAPP === 'undefined' && _this.type !== 'vr') {
                    if (!_this.loading) {
                        _this.log("loading sdk: " + _this.sdk);
                        _this.loading = true;
                        load(_this.sdk)
                            .then(function () {
                            // 修改挂载sdk命名
                            _this.fixGlobalName();
                            var length = _this.queues.length;
                            for (var i = 0; i < length; i++) {
                                _this.log('flush queues after sdk loaded');
                                _this.queues.pop()();
                            }
                        })
                            .catch(function (error) { return _this.log("load sdk failed!, " + error, TYPE.ERROR); });
                    }
                    _this.log('sdk is loading, push task in queues');
                    _this.queues.push(taskFunc.bind(_this.actions, params, callback));
                    return Promise.reject(new Error('sdk is loading')).catch(function (e) { return _this.log(e.message); });
                }
                _this.log("delegate " + action + " call with params: " + JSON.stringify(params));
                return taskFunc.call(_this.actions, params, callback);
            };
            return this;
        };
        return Hybrid;
    }());
    var hybrid = null;
    var index = (function (config) {
        if (hybrid) {
            return hybrid;
        }
        hybrid = new Hybrid(config);
        return hybrid;
    });

    return index;

})));
